/* ─────────────────────────────────────────────────────────────
   PP-MEDIA — Counter sync with Flickity
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var counter = document.querySelector('[data-pp-media-current]');
  if (!counter) return;

  function initCounter() {
    var slider = document.querySelector('#Product-Slider');
    if (!slider || !window.Flickity) {
      setTimeout(initCounter, 200);
      return;
    }

    // Get ALL Flickity instances on this element
    // Theme creates two — we want the first one (guid 1)
    var instances = [];
    var guid = 1;
    while (true) {
      var f = slider['flickity' + guid];
      if (!f) break;
      instances.push(f);
      guid++;
    }

    // Fallback — use Flickity.data which returns the last instance
    var flkty = instances[0] || Flickity.data(slider);
    if (!flkty) {
      setTimeout(initCounter, 200);
      return;
    }

    // Set correct value immediately
    counter.textContent = flkty.selectedIndex + 1;

    // Update on every slide change
    flkty.on('change', function (index) {
      counter.textContent = index + 1;
    });
  }

  initCounter();

});


/* ─────────────────────────────────────────────────────────────
   PP-MEDIA LIGHTBOX
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var lightbox  = document.querySelector('.pp-media__lightbox');
  var closeBtns = document.querySelectorAll('.pp-media__lightbox-close, .pp-media__lightbox-back');

  // Bind to ALL see-all buttons — removed single querySelector
  document.querySelectorAll('.product-thumbnail--see-all').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (lightbox) lightbox.classList.add('is-active');
    });
  });

  // Close buttons — remove is-active
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (lightbox) lightbox.classList.remove('is-active');
    });
  });

  // Close on backdrop click
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        lightbox.classList.remove('is-active');
      }
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-active')) {
      lightbox.classList.remove('is-active');
    }
  });

});


/* ─────────────────────────────────────────────────────────────
   PP-LIGHTBOX — Sidebar chapter navigation
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var sidebarBtns   = Array.from(document.querySelectorAll('[data-pp-lightbox-chapter-btn]'));
  var content       = document.querySelector('[data-pp-lightbox-content]');
  var isClickScroll = false; // ← flag

  sidebarBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.dataset.ppLightboxChapterBtn;

      // Remove is-active from all, add to clicked
      sidebarBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      // Set flag — ignore scroll updates while animating
      isClickScroll = true;

      var target = document.querySelector('[data-pp-lightbox-chapter="' + idx + '"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Release flag after scroll animation completes (~600ms)
      setTimeout(function () {
        isClickScroll = false;
      }, 600);
    });
  });

  // Update active sidebar btn when scrolling — skip if triggered by click
  if (content) {
    content.addEventListener('scroll', function () {
      if (isClickScroll) return; // ← ignore during click scroll

      var chapters  = Array.from(document.querySelectorAll('[data-pp-lightbox-chapter]'));
      var scrollTop = content.scrollTop + 40;

      chapters.forEach(function (chapter, i) {
        var top    = chapter.offsetTop;
        var bottom = top + chapter.offsetHeight;
        if (scrollTop >= top && scrollTop < bottom) {
          sidebarBtns.forEach(function (b) { b.classList.remove('is-active'); });
          if (sidebarBtns[i]) sidebarBtns[i].classList.add('is-active');
        }
      });
    });
  }

});


/* ─────────────────────────────────────────────────────────────
   PP-REVIEW SIDEBAR
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var sidebar    = document.querySelector('.pp-review-sidebar');
  var openBtns   = document.querySelectorAll('.pp-review-sidebar-view');
  var closeBtns  = document.querySelectorAll('.pp-review-sidebar-close, .pp-review-sidebar-bottom-btn');
  var overlay    = document.querySelector('.pp-review-sidebar-overlay');
  // dev-build 247: one Yotpo widget on the page. It lives in the review section and
  // moves into the drawer while the drawer is open, so it loads once and both show it.
  var widget     = document.querySelector('[data-pp-reviews-widget]');
  var home       = document.querySelector('[data-pp-reviews-home]');
  var drawerSlot = document.querySelector('[data-pp-reviews-drawer]');

  function openSidebar() {
    if (!sidebar) return;
    if (widget && drawerSlot && widget.parentNode !== drawerSlot) {
      if (home) home.style.minHeight = home.offsetHeight + 'px';
      drawerSlot.appendChild(widget);
    }
    sidebar.classList.add('is-active');
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-active');
    if (widget && home && widget.parentNode !== home) {
      home.appendChild(widget);
      home.style.minHeight = '';
    }
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openSidebar();
    });
  });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeSidebar); });
  if (overlay) overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-active')) closeSidebar();
  });

});

/* ─────────────────────────────────────────────────────────────
   PP-MODAL TILES
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var container  = document.querySelector('[data-pp-modal-container]');
  var titleEl    = document.querySelector('[data-pp-modal-title]');
  var noteEl     = document.querySelector('[data-pp-modal-note]');
  var panels     = document.querySelectorAll('[data-pp-modal-panel]');
  var openBtns   = document.querySelectorAll('[data-pp-modal-open]');
  var closeBtns  = document.querySelectorAll('[data-pp-modal-close]');

  if (!container) return;

  function openModal(idx) {
    // Hide all panels
    panels.forEach(function (p) { p.hidden = true; });

    // Show target panel
    var panel = document.querySelector('[data-pp-modal-panel="' + idx + '"]');
    if (panel) panel.hidden = false;

    // Update title and note from button data
    var btn = document.querySelector('[data-pp-modal-open="' + idx + '"]');
    if (btn) {
      var title = btn.querySelector('.pp-modal-tile-row__title');
      var note  = btn.querySelector('.pp-modal-tile-row__note');
      if (titleEl) titleEl.textContent = title ? title.textContent : '';
      if (noteEl)  noteEl.textContent  = note  ? note.textContent  : '';
    }

    container.classList.add('is-active');
    document.body.classList.add('pp-modal-open');
  }

  function closeModal() {
    container.classList.remove('is-active');
    document.body.classList.remove('pp-modal-open');
  }

  // Open
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal(btn.dataset.ppModalOpen);
    });
  });

  // Close
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

});


/* ─────────────────────────────────────────────────────────────
   YOTPO DATE FORMAT — reformat dates after Yotpo renders
───────────────────────────────────────────────────────────────*/
function reformatYotpoDates() {
  var dates = document.querySelectorAll('.yotpo-date-format');
  dates.forEach(function (el) {
    var raw = el.textContent.trim(); // e.g. "22/05/25"
    if (!raw || !raw.match(/^\d{2}\/\d{2}\/\d{2}$/)) return;

    var parts = raw.split('/');
    var day   = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1; // 0-indexed
    var year  = 2000 + parseInt(parts[2], 10);

    var date = new Date(year, month, day);
    var months = ['Jan','Feb','Mar','Apr','May','Jun',
                  'Jul','Aug','Sep','Oct','Nov','Dec'];

    var formatted = day + ' ' + months[date.getMonth()] + ' ' + String(year).slice(2);
    el.textContent = formatted; // e.g. "22 May 25"
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', function () {
  // Yotpo loads async — observe DOM for date elements appearing
  var observer = new MutationObserver(function () {
    var dates = document.querySelectorAll('.yotpo-date-format');
    if (dates.length > 0) {
      reformatYotpoDates();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* ─────────────────────────────────────────────────────────────
   PP-BOOKING CARD — Branch toggle
───────────────────────────────────────────────────────────────*/
document.addEventListener('DOMContentLoaded', function () {

  var editBtn   = document.querySelector('.pp-booking-card-edit-btn');
  var cancelBtn = document.querySelector('.pp-booking-card-branch-cancel');
  var branch    = document.querySelector('.pp-booking-card-branch');

  if (!branch) return;

  /* The Edit button no longer opens this panel.

     .pp-booking-card-branch is a location-and-date picker nested inside the booking
     card — a second place to change the booking, duplicating the global bar. It was
     never asked for. Edit now opens the global bar, which is the one place a booking
     is edited; the handler lives in booking-bar.js, delegated from document.

     There were TWO listeners on this button, both opening this panel: this one and a
     second at the bottom of this file calling openBranchPanel(). Both are gone.

     The markup, CSS and the rest of the branch JS are left in place for now — the
     panel is simply unreachable. Removing them is ~50 references across three files
     and wants its own pass, not this one. */

  // Close
  if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
          branch.classList.remove('is-open');
      });
  }

});


/* ─────────────────────────────────────────────────────────────
   PP-BOOKING CARD — WORKING
───────────────────────────────────────────────────────────────*/

// ── State ──────────────────────────────────────────────────────────────────
let currentBooking = {
    locationGid:  null,
    startDate:    null,
    endDate:      null,
    locationData: null,
};

let branchState = {
    locationHandle: null,
    startDate:      null,
    endDate:        null,
};

let currentQty          = 1;
let lastSelectedOption2 = null; // ← add

// ── Booking bar changed ────────────────────────────────────────────────────
function onBookingBarChanged(e) {
    const { locationGid, startDate, endDate } = e.detail || {};

    // Normalize — ensure full GID format
    const normalizedGid = locationGid && !String(locationGid).startsWith('gid://')
        ? `gid://shopify/Metaobject/${locationGid}`
        : locationGid;

    let locationData = null;
    if (normalizedGid && window.locationMetaobjects) {
        const incomingId = String(normalizedGid).replace('gid://shopify/Metaobject/', '');
        locationData = Object.values(window.locationMetaobjects).find(l => {
            const storedId = String(l.gid).replace('gid://shopify/Metaobject/', '');
            return storedId === incomingId;
        }) || null;
    }

    /*  ── AN INCOMPLETE EVENT IS NOT A CLEARED BOOKING (10-09-2026) ──────────────
        This used to overwrite currentBooking with whatever the event carried, then
        call updatePDPBookingCard — which resets the card whenever the booking is
        incomplete.

        The bar dispatches more than once as the page settles, and not every dispatch
        carries all three values. So the card filled in, a partial event wiped the
        location, the dates and the nights line, and the next full event put them back.
        That is the flicker: values present, gone, present again.

        A partial event now leaves the card alone. It is the same guard booking-bar.js
        already applies to its own listener — it returns early unless locationGid,
        startDate and endDate are all present — so the bar and the card treat these
        events alike.

        Clearing still works, because clearing is not a partial event: every field
        arrives null, which is what the second test catches. */
    const complete = normalizedGid && startDate && endDate;
    const cleared  = !normalizedGid && !startDate && !endDate;

    if (!complete && !cleared) return;

    currentBooking = { locationGid: normalizedGid, startDate, endDate, locationData };
    updatePDPBookingCard();
}

// ── Update PDP booking card statues ───────────────────────────────────────
function updatePDPBookingCard() {
    const { startDate, endDate, locationData } = currentBooking;
    const hasBooking = startDate && endDate && locationData;

    if (!hasBooking) {
        resetPDPBookingCard();
        updatePDPPrice();
        return;
    }

    const { nightsCharged, freeLabels } = computeNights(startDate, endDate, locationData);
    const totalNights  = Math.round((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24));
    const closedNights = totalNights - nightsCharged;

    let infoText = window.djwNightsText(startDate, endDate, locationData, 'long');   /* 575 */

    const locationEl = document.querySelector('.pp-booking-card-statue-location');
    if (locationEl) {
        locationEl.textContent = locationData?.suburb || locationData?.name || '';
        locationEl.classList.add('active');
    }

    const datesEl = document.querySelector('.pp-booking-card-statue-date');
    if (datesEl) {
        datesEl.textContent = `${formatDate(startDate)} - ${formatDate(endDate)}`;
        datesEl.classList.add('active');
    }

    const editBtn = document.querySelector('.pp-booking-card-edit-btn');
    if (editBtn) editBtn.classList.add('active');

    const infoEl = document.querySelector('.pp-booking-card-statue-info');
    if (infoEl) infoEl.textContent = infoText;

    // ── Cancel date ────────────────────────────────────────────
    const cancelEl = document.querySelector('.pp-booking-cancel-date');
    /*  421: put "Free cancellation until" back in front of the date once dates exist. */
    const cancelTitle = document.querySelector('[data-cancel-title]'), cancelWith = document.querySelector('[data-cancel-with]');
    if (cancelTitle && cancelEl && startDate && cancelWith) {
        cancelTitle.textContent = (cancelWith.textContent || '').trim() + ' ';
        cancelTitle.appendChild(cancelEl); cancelEl.hidden = false;
    }
    if (cancelEl && startDate) {
        const cancelDate = new Date(startDate);
        const cancelDays = window.ppSection?.cancellation_days || 0;
        cancelDate.setDate(cancelDate.getDate() - cancelDays);
        /*  The card's own dates come from formatDate(), which said "Sept", while this
            line had a local list saying "Sep" — two spellings inside one card. One
            list, in charged-nights.js. */
        const D = window.DAYS_SHORT;
        const M = window.MONTHS_SHORT;
        cancelEl.textContent = `${D[cancelDate.getDay()]} ${cancelDate.getDate()} ${M[cancelDate.getMonth()]}`;
    }

    // ── Update CTA state ─────
    if (typeof window.updateCTAState === 'function') window.updateCTAState();

    updatePDPAvailability();
    updatePDPPrice();
    updatePerUnitPriceFromSelected();
    updateRowPrices();
    updateCapacitySecondOptionPrices();
}

// ── Reset PDP booking card statues ─────────────────────────────────────────
function resetPDPBookingCard() {
    const locationEl = document.querySelector('.pp-booking-card-statue-location');
    const datesEl    = document.querySelector('.pp-booking-card-statue-date');
    const infoEl     = document.querySelector('.pp-booking-card-statue-info');
    const editBtn    = document.querySelector('.pp-booking-card-edit-btn');
    const bandEl     = document.querySelector('.pp-booking-card-available');
    const cancelEl = document.querySelector('.pp-booking-cancel-date');

    if (locationEl) { locationEl.textContent = ''; locationEl.classList.remove('active'); }
    if (datesEl)    { datesEl.textContent    = ''; datesEl.classList.remove('active'); }
    if (infoEl)       infoEl.textContent     = '';
    if (editBtn)      editBtn.classList.remove('active');
    if (bandEl)       bandEl.style.display   = 'none';
    if (cancelEl) cancelEl.textContent = '';
    /*  421: no dates, so the line says how cancellation works instead of "until" and a blank. */
    const cancelTitle = document.querySelector('[data-cancel-title]');
    if (cancelTitle && cancelEl) { cancelTitle.textContent = cancelTitle.getAttribute('data-without') || ''; cancelEl.hidden = true; cancelTitle.appendChild(cancelEl); }

    // ── Update CTA state ─────
    if (typeof window.updateCTAState === 'function') window.updateCTAState();
}

// ── PDP availability band ──────────────────────────────────────────────────
function updatePDPAvailability() {
    const { locationGid, startDate, endDate, locationData } = currentBooking;
    const bandEl  = document.querySelector('.pp-booking-card-available');
    const titleEl = document.querySelector('.pp-booking-card-available-title');
    const textEl  = document.querySelector('.pp-booking-card-available-text');
    if (!bandEl) return;

    bandEl.classList.remove('is-bookedout', 'is-substitute', 'is-override');

    const hasBooking = startDate && endDate && locationData;
    if (!hasBooking) {
        bandEl.style.display = 'none';
        return;
    }

    bandEl.style.display = '';

    const productGid = document.querySelector('[data-product-gid]')?.dataset.productGid;
    const suburb     = locationData?.suburb || locationData?.name || '';

    /*  ── REPOINTED ONTO THE SHARED BLACKOUT RULE, dev-build 184 ─────────────────
        This band was correct and starved, and then correct and WRONG. Its date test
        read override.nights_from / nights_to, renamed to first_night / last_night in
        dev-build 182, so the guard was false on every record and the comparison never
        ran: any product named in a block record was "Booked out on those dates" on
        every date. It also skipped any record with no locations, so a store-wide
        blackout said nothing here.

        Both faults are fixed in one place now. The block verdict comes from the shared
        rule; the other three effects keep their own loop, because they are messages
        rather than verdicts and each surface words them differently — but they take
        their DATE and LOCATION tests from the same rule, so no two surfaces can
        disagree about whether a record applies.

        NOT DONE HERE, deliberately: the variant picker is not greyed and the cascaded
        options are not marked. Both need a drawn treatment — visible, not selectable,
        and labelled in words — and that design has not been made yet. An undrawn
        treatment invented in code is how turn 1 of the surface designs was wasted.   */
    const B = window.DJWBlackout;
    const overrides = window.csOverrides;

    if (B && B.productBlocked(productGid, startDate, endDate, locationGid)) {
        ppBcMessage(''); delete bandEl.dataset.pill;
        bandEl.classList.add('is-bookedout');
        if (titleEl) titleEl.textContent = window.ppSection?.avail_out || 'Booked out on those dates';
        if (textEl)  textEl.textContent  = `Not available for you at the ${suburb} branch.`;
        return;
    }

    if (!B || !Array.isArray(overrides) || !overrides.length) {
        showPDPAvailable(bandEl, titleEl, textEl, suburb);
        return;
    }

    for (const override of overrides) {
        /*  block is answered above, by the shared rule, including the cascade and the
            variants channel. Re-testing it here would be the second owner. */
        if (override.effect === 'block') continue;
        if (!override.products?.length) continue;

        const targetsProduct = override.products.some(p =>
            String(p).split('/').pop() === String(productGid).split('/').pop()
        );
        if (!targetsProduct) continue;

        if (!B.locationApplies(override, locationGid)) continue;
        if (!B.hireHitsRecord(startDate, endDate, override)) continue;

        /*  455 (Ben 15-10-2026): the status shows whether or not there is a message —
            the pill says it ("Low stock"). The old amber band is no longer used for these;
            a message, only when one is typed, goes in the record's chosen place: a callout
            from the pill (8b) or a strip under Your booking (8c). */
        const label = { substitute: window.ppSection?.avail_substitute || 'Available with one swap', low_stock: 'Low stock', notice: 'Good to know' }[override.effect];
        if (label) {
            bandEl.classList.add(override.effect === 'substitute' ? 'is-substitute' : 'is-override');
            bandEl.dataset.pill = override.effect === 'substitute' ? 'One swap' : label;
            if (titleEl) titleEl.textContent = label;
            if (textEl)  textEl.textContent  = '';
            ppBcMessage(override.message || '', override.message_style || 'callout', label);
            return;
        }
    }

    showPDPAvailable(bandEl, titleEl, textEl, suburb);
}

function ppBcMessage(text, style, label) {
    document.querySelectorAll('.pp-bc-msg').forEach(n => n.remove());
    const head = document.querySelector('.pp-bc .pp-bc-head');
    if (!text || !head) return;
    const el = document.createElement('div');
    el.className = 'pp-bc-msg pp-bc-msg--' + (style === 'strip' ? 'strip' : 'callout');
    el.setAttribute('role', 'note');
    if (style === 'strip') {
        el.innerHTML = '<span class="pp-bc-msg__dot" aria-hidden="true"></span><span><strong></strong> <span class="pp-bc-msg__t"></span></span>';
        el.querySelector('strong').textContent = label + '.';
        el.querySelector('.pp-bc-msg__t').textContent = text;
        head.parentNode.insertBefore(el, head);
    } else {
        el.textContent = text;
        head.insertAdjacentElement('afterend', el);
    }
}

function showPDPAvailable(bandEl, titleEl, textEl, suburb) {
    ppBcMessage('');
    delete bandEl.dataset.pill;
    bandEl.classList.remove('is-bookedout', 'is-substitute', 'is-override');
    if (titleEl) titleEl.textContent = window.ppSection?.avail_available || 'Available on your dates';
    if (textEl)  textEl.textContent  = `We've got these ready for you at the ${suburb} branch.`;
}

// ── Branch panel ───────────────────────────────────────────────────────────
function initBranchPanel() {

    // ── Location click ─────────────────────────────────────────────
    document.querySelectorAll('.pp-booking-card-branch-location').forEach(btn => {
        btn.addEventListener('click', function () {
            document.querySelectorAll('.pp-booking-card-branch-location')
                .forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            branchState.locationHandle = this.dataset.location;
            updateBranchInfo();
        });
    });

    // ── Night chip click ───────────────────────────────────────────
    document.querySelectorAll('.pp-booking-card-branch-night').forEach(btn => {
        btn.addEventListener('click', function () {
            document.querySelectorAll('.pp-booking-card-branch-night')
                .forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            if (!branchState.startDate || !branchState.locationHandle) return;

            const locationData = window.locationMetaobjects?.[branchState.locationHandle];
            if (!locationData) return;

            let nights = 0;
            if (this.dataset.nights === 'week')       nights = 7;
            else if (this.dataset.nights === 'month') nights = 30;
            else                                      nights = parseInt(this.dataset.nights, 10);

            branchState.endDate = calcEndDate(branchState.startDate, nights);
            updateBranchInfo();
        });
    });

    // ── Use these dates ────────────────────────────────────────────
    const updateBtn = document.querySelector('.pp-booking-card-branch-update');
    if (updateBtn) {
        updateBtn.addEventListener('click', function () {
            const { locationHandle, endDate } = branchState;
            const startDate = branchState.startDate || currentBooking.startDate;

            if (!locationHandle || !startDate || !endDate) return;

            const locationData = window.locationMetaobjects?.[locationHandle];
            if (!locationData) return;

            window.bookingDates = { start: startDate, end: endDate };

            // dispatchBookingBarChanged(startDate, endDate, locationData);
            document.dispatchEvent(new CustomEvent('bookingbar:changed', {
                detail: {
                    locationGid: locationData.gid
                        ? (String(locationData.gid).startsWith('gid://')
                            ? locationData.gid
                            : `gid://shopify/Metaobject/${locationData.gid}`)
                        : null,
                    startDate,
                    endDate,
                    fromBranch: true
                }
            }));
            
            updateTopBarTitle(startDate, endDate, locationData);

            // ── Update top bar location ────────────────────────────
            const locationEl = document.querySelector('.bb-pickup-from');
            if (locationEl) {
                locationEl.textContent = locationData?.suburb || locationData?.name || '';
                locationEl.classList.add('active');
            }

            // ── Update top bar hire dates ──────────────────────────
            const hireDatesEl = document.querySelector('.bb-hire-dates');
            if (hireDatesEl) {
                hireDatesEl.textContent = `${formatDate(startDate)} - ${formatDate(endDate)}`;
                hireDatesEl.classList.add('active');
            }

            // ── Sync active location in booking bar panel ──────────
            document.querySelectorAll('.bb-panel-location').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.location === locationHandle);
            });

            // ── Update calendar selection ──────────────────────────
            if (typeof updateCalendarSelection === 'function') {
                updateCalendarSelection();
            }

            // ── Force update PDP card immediately ──────────────────
            currentBooking = {
                locationGid:  locationData.gid || null,
                startDate,
                endDate,
                locationData,
            };

            updatePDPBookingCard();
            updatePerUnitPriceFromSelected();
            updateRowPrices();

            document.querySelector('.pp-booking-card-branch')?.classList.remove('is-open');
        });
    }

    // ── Cancel ─────────────────────────────────────────────────────
    const cancelBtn = document.querySelector('.pp-booking-card-branch-cancel');
    if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
            syncBranchStateFromBooking();
            document.querySelector('.pp-booking-card-branch')?.classList.remove('is-open');
        });
    }

    /* Second Edit listener removed — see the note further up this file. Both this and
       the one in the DOMContentLoaded block opened .pp-booking-card-branch, so the
       button was wired twice to the same unwanted panel. */
}

// ── Open branch panel ─────────────────────────────────────────────────────
function openBranchPanel() {
    syncBranchStateFromBooking();
    document.querySelector('.pp-booking-card-branch')?.classList.add('is-open');
}

// ── Price section ──────────────────────────────────────────────────────────
/* getLocationHours() is gone from this file — B19, 11-09-2026. There were TWO copies
   of it here, this one and another inside the add-to-cart block, and they behaved
   differently: that one never stripped the weekday prefix. Both now call
   window.hoursFor from charged-nights.js, which also applies Special Trading Date
   overrides (#64). See the block comment above hoursFor() there. */

function updatePDPPrice() {
    const { startDate, endDate, locationData } = currentBooking;
    const hasBooking = startDate && endDate && locationData;

    const fromEl       = document.querySelector('.pp-booking-card-price-from');
    const priceEl      = document.querySelector('.pp-booking-card-price');
    const forNightsEl  = document.querySelector('.pp-booking-card-price-for-nights');
    const subtitleEl   = document.querySelector('.pp-booking-card-price-subtitle');
    const pickReturnEl  = document.querySelector('.pp-booking-card-price-pick-return');
    const pickEl       = document.querySelector('.pp-booking-card-price-pick');
    const returnEl     = document.querySelector('.pp-booking-card-price-return');
    const breakdownBtn = document.querySelector('.pp-booking-card-price-breakdown');

    if (!hasBooking) {
        // Show "From" + base price, hide dynamic elements
        if (fromEl)       fromEl.style.display      = '';
        if (forNightsEl)  forNightsEl.textContent   = '';
        if (subtitleEl)   subtitleEl.classList.remove('active');   // ← add
        if (pickReturnEl) pickReturnEl.classList.remove('active'); // ← add
        if (pickEl)       pickEl.textContent        = '';
        if (returnEl)     returnEl.textContent      = '';
        if (breakdownBtn) breakdownBtn.classList.remove('is-visible', 'active');
        resetPDPBreakdown();
        return;
    }

    const { nightsCharged, freeLabels } = computeNights(startDate, endDate, locationData);
    const totalNights  = Math.round((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24));

    // ── Save selected option2 before updating ─────────────────
    const select       = document.querySelector('.pp-booking-card-mode-variant-options');
    const savedOption2 = lastSelectedOption2 || select?.options[select.selectedIndex]?.dataset.option2;

    // ── Matrix mode — update options with dynamic price ────────
    updateMatrixOptions(nightsCharged);

    // ── Restore selected option after update ──────────────────
    if (savedOption2 && select) {
        const targetOpt = [...select.options].find(o => o.dataset.option2 === savedOption2);
        if (targetOpt) select.value = targetOpt.value;
    }

    // ── Sync top price after restore ──────────────────────────
    updateMatrixTopPrice(nightsCharged);

    // ── Resolve price from hire periods ───────────────────────
    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data      = window.ppProductData?.[productId];
    let price       = data ? resolvePrice(productId, nightsCharged) : null;

    // ── Matrix fallback — get price from selected variant ─────
    if (price === null) {
        const option2 = savedOption2; // ← use savedOption2 directly
        if (option2 && data?.variants?.length) {
            const option1 = getMatrixOption1(nightsCharged, data.variants);
            const variant = data.variants.find(v =>
                v.option1 === option1 && v.option2 === option2
            );
            if (variant) price = variant.price;
        }
    }

    // ── Hide "From", show calculated price ────────────────────
    if (fromEl) fromEl.style.display = 'none';

    if (price !== null && priceEl) {
      // Remove all text nodes first
      [...priceEl.childNodes]
          .filter(n => n.nodeType === Node.TEXT_NODE)
          .forEach(n => n.remove());
      // Add new price text node
      priceEl.appendChild(document.createTextNode(' ' + formatMoney(price)));
    }

    // ── For nights ────────────────────────────────────────────
    if (forNightsEl) {
        forNightsEl.innerHTML = window.djwNightsHTML(startDate, endDate, locationData);   /* 577 */
    }

    // ── Subtitle — charged as X nights ───────────────────────
    if (subtitleEl) {
        let subtitle = window.djwNightsText(startDate, endDate, locationData, 'long');   /* 575 */
        subtitleEl.textContent = subtitle;
        subtitleEl.classList.add('active');
    }

    // ── Pick up / return ──────────────────────────────────────
    const pickupTime = window.hoursFor(startDate, locationData, 'pickup');
    const returnTime = window.hoursFor(endDate,   locationData, 'return');

    if (pickReturnEl) pickReturnEl.classList.add('active');
    if (pickEl) {
        pickEl.textContent = `Pick up ${formatDate(startDate)}, ${pickupTime}`;
    }
    if (returnEl) {
        returnEl.textContent = `Return ${formatDate(endDate)}, ${returnTime}`;
    }

    // ── Show breakdown button ──────────────────────────────────
    if (breakdownBtn) breakdownBtn.classList.add('is-visible');

    // ── Breakdown ─────────────────────────────────────────────
    updatePDPBreakdown(price, nightsCharged);
}

// ── Resolve price (mirrors collection-split.js) ───────────────────────────
function resolvePrice(productId, nightsCharged) {
    const isPerUnit = window.ppSection?.booking_card_mode === 'perUnit';
    const isPackage = window.ppSection?.booking_card_mode === 'package';
    if (isPerUnit || isPackage) return null; // ← handled by updatePerUnitPriceFromSelected

    const data = window.ppProductData?.[productId];
    if (!data) return null;

    const { hirePeriods, variants } = data;
    if (!hirePeriods?.length || !variants?.length) return null;

    const rung = hirePeriods.find(r => nightsCharged >= r.from && nightsCharged <= r.to);
    if (!rung) return null;

    const needle  = rung.variant_option.toLowerCase();
    const variant = variants.find(v => (v.option || '').toLowerCase() === needle);
    if (!variant) return null;

    return variant.price;
}

// ── Format money ───────────────────────────────────────────────────────────
function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
}

// ── Format dates as DD-MM-YYYY ─────────────────────────
function formatDateDMY(isoDate) {
    const d  = new Date(isoDate);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}-${mm}-${d.getFullYear()}`;
}

// ── Update breakdown ───────────────────────────────────────────────────────
function updatePDPBreakdown(price, nightsCharged) {
    const titleEl  = document.querySelector('.pp-booking-card-price-breakdown-content-title');
    const priceEl  = document.querySelector('.pp-booking-card-price-breakdown-content-price');
    const optionEl = document.querySelector('.pp-booking-card-price-breakdown-content-option-value');

    const productId    = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data         = window.ppProductData?.[productId];
    const productTitle = document.querySelector('[data-product-title]')?.dataset.productTitle
        || document.title.split('-')[0].trim();

    // ── Title ──────────────────────────────────────────────────
    if (titleEl) {
        const isPerUnit = window.ppSection?.booking_card_mode === 'perUnit';
        if (isPerUnit) {
            titleEl.textContent = `${productTitle} x ${currentQty} (${nightsCharged} ${nightsCharged === 1 ? 'night' : 'nights'} hire)`;
        } else {
            titleEl.textContent = `${productTitle} (${nightsCharged} ${nightsCharged === 1 ? 'night' : 'nights'} hire)`;
        }
    }

    // ── Price ──────────────────────────────────────────────────
    if (priceEl && price !== null) {
        const isPerUnit = window.ppSection?.booking_card_mode === 'perUnit';
        priceEl.textContent = isPerUnit
            ? formatMoney(price * currentQty)
            : formatMoney(price);
    }

    // ── Option lines ───────────────────────────────────────────
    if (optionEl) {
        const isPerUnit = window.ppSection?.booking_card_mode === 'perUnit';
        const isPackage = window.ppSection?.booking_card_mode === 'package';
        const isCapacity = window.ppSection?.booking_card_mode === 'capacity';

        if (isPerUnit || isPackage || isCapacity) {
            const option1         = getMatrixOption1(nightsCharged, data?.variants || []);
            const optionContainer = optionEl.parentElement;

            // ── Collect selected values FIRST ──────────────────
            const selectedValues = {};
            document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(b => {
                selectedValues[parseInt(b.dataset.optionIndex)] = b.dataset.value;
            });
            document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
                const idx = parseInt(select.dataset.optionIndex);
                const selectedOpt = select.options[select.selectedIndex];
                if (selectedOpt) selectedValues[idx] = selectedOpt.dataset.value;
            });

            // Remove existing option lines
            optionContainer.querySelectorAll('.pp-breakdown-option-line').forEach(el => el.remove());

            // ── Helper: build allFirstValues from all option sources ──
            function buildAllFirstValues() {
                const allFirstValues = {};
                const isCapacity = window.ppSection?.booking_card_mode === 'capacity';

                document.querySelectorAll('.pp-bcm-variant-box').forEach((b, boxIndex) => {
                    const isFirstContainer = boxIndex === 0;
                    // For capacity mode, use selected value for first container
                    // For all others, use first button value
                    const btn = (isCapacity && isFirstContainer)
                        ? b.querySelector('.pp-bcm-variant.is-selected') || b.querySelector('.pp-bcm-variant')
                        : b.querySelector('.pp-bcm-variant');
                    if (!btn || !btn.dataset.value) return;
                    allFirstValues[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
                });

                document.querySelectorAll('.pp-bcm-variant-select').forEach(s => {
                    const firstOptVal = s.options[0]?.dataset.value;
                    if (!firstOptVal) return;
                    allFirstValues[parseInt(s.dataset.optionIndex)] = firstOptVal;
                });
                return allFirstValues;
            }

            // ── Helper: find variant by option map ────────────────────
            function findVariant(optionMap) {
                return data?.variants?.find(v => {
                    if (v.option1 !== option1) return false;
                    return Object.entries(optionMap).every(([idx, val]) => {
                        const optKey = `option${parseInt(idx) + 1}`;
                        return v[optKey] !== undefined && v[optKey] === val;
                    });
                });
            }

            // ── Helper: build and append a line ───────────────────────
            let appendLineCount = 0;
            function appendLine(label, priceDiff) {
                const line = document.createElement('span');
                line.className = 'pp-booking-card-price-breakdown-content-option-value pp-breakdown-option-line';
                line.textContent = label.split(' (')[0];

                const isFirstLine = appendLineCount === 0;
                const hideAccessory = isCapacity && isFirstLine;

                if (priceDiff > 0 && !hideAccessory) {
                    const accessory = document.createElement('span');
                    accessory.className = 'pp-option-accessory';
                    accessory.textContent = isPerUnit
                        ? `+${formatMoney(priceDiff)} each`
                        : `+${formatMoney(priceDiff)}`;
                    line.appendChild(accessory);
                }

                appendLineCount++;
                optionContainer.appendChild(line);
            }

            // ── Button option lines ────────────────────────────────────
            document.querySelectorAll('.pp-bcm-variant-box').forEach(box => {
                const buttons     = box.querySelectorAll('.pp-bcm-variant');
                const selectedBtn = box.querySelector('.pp-bcm-variant.is-selected');
                if (!selectedBtn) return;

                const optionIndex = parseInt(selectedBtn.dataset.optionIndex);
                const selectedVal = selectedBtn.dataset.value;
                const firstVal    = buttons[0].dataset.value;

                const allFirstValues  = buildAllFirstValues();
                const selectedSingle  = { ...allFirstValues, [optionIndex]: selectedVal };
                const baseSingle      = { ...allFirstValues, [optionIndex]: firstVal };

                const selectedVariant = findVariant(selectedSingle);
                const baseVariant     = findVariant(baseSingle);
                const priceDiff       = selectedVariant && baseVariant
                    ? selectedVariant.price - baseVariant.price
                    : 0;

                appendLine(selectedVal, priceDiff);
            });

            // ── Dropdown option lines ──────────────────────────────────
            document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
                const optionIndex = parseInt(select.dataset.optionIndex);
                const selectedOpt = select.options[select.selectedIndex];
                const firstOpt    = select.options[0];
                if (!selectedOpt || !firstOpt) return;

                const selectedVal = selectedOpt.dataset.value;
                const firstVal    = firstOpt.dataset.value;

                const allFirstValues  = buildAllFirstValues();
                const selectedSingle  = { ...allFirstValues, [optionIndex]: selectedVal };
                const baseSingle      = { ...allFirstValues, [optionIndex]: firstVal };

                const selectedVariant = findVariant(selectedSingle);
                const baseVariant     = findVariant(baseSingle);
                const priceDiff       = selectedVariant && baseVariant
                    ? selectedVariant.price - baseVariant.price
                    : 0;

                appendLine(selectedVal, priceDiff);
            });

            // ── Summary line ───────────────────────────────────────────
            const unitLabel   = (document.querySelector('[data-product-title]')?.dataset.productTitle || '').toLowerCase();
            const unit        = unitLabel.includes('light') ? 'light' : unitLabel.includes('ball') ? 'ball' : 'unit';
            const totalNights = Math.round((new Date(currentBooking.endDate) - new Date(currentBooking.startDate)) / (1000 * 60 * 60 * 24));

            if (isPerUnit) {
                optionEl.textContent = `${formatMoney(price)} per ${unit} for ${totalNights} ${totalNights === 1 ? 'night' : 'nights'}`;
            }
        } else {
            const select  = document.querySelector('.pp-booking-card-mode-variant-options');
            const option2 = select?.options[select.selectedIndex]?.dataset.option2;

            if (option2 && price !== null) {
                const area    = getAreaFromOption2(option2);
                const dims    = getDimsFromOption2(option2);
                const sqm     = parseInt(area);
                const panels  = sqm * 4;
                const perSqm  = Math.round(price / sqm / 100);

                optionEl.textContent = `${dims} — ${area}, ${panels} panels`;

                let perLine = document.querySelector('.pp-breakdown-per-sqm');
                if (!perLine) {
                    perLine = document.createElement('span');
                    perLine.className = 'pp-booking-card-price-breakdown-content-option-value pp-breakdown-per-sqm';
                    optionEl.parentElement.appendChild(perLine);
                }
                perLine.textContent = `$${perSqm} per m² for ${nightsCharged} ${nightsCharged === 1 ? 'night' : 'nights'}`;

            } else if (data?.hirePeriods?.length) {
                const isMatrix = window.ppSection?.booking_card_mode === 'matrix';
                if (!isMatrix) {
                    const rung = data.hirePeriods.find(r => nightsCharged >= r.from && nightsCharged <= r.to);
                    if (rung) {
                        const needle  = rung.variant_option.toLowerCase();
                        const variant = data.variants?.find(v =>
                            (v.option || '').toLowerCase() === needle
                        );
                        if (variant && price !== null) {
                            const perNight = price / nightsCharged / 100;
                            const perStr   = '$' + (perNight % 1 === 0 ? perNight.toFixed(0) : perNight.toFixed(2));
                            optionEl.textContent = `${variant.option} · ${perStr} per night`;
                        }
                    }
                }
            }
        }
    }
}

// ── Reset breakdown ────────────────────────────────────────────────────────
function resetPDPBreakdown() {
    const titleEl      = document.querySelector('.pp-booking-card-price-breakdown-content-title');
    const priceEl      = document.querySelector('.pp-booking-card-price-breakdown-content-price');
    const optionEl     = document.querySelector('.pp-booking-card-price-breakdown-content-option-value');
    const content      = document.querySelector('.pp-booking-card-price-breakdown-content');
    const breakdownBtn = document.querySelector('.pp-booking-card-price-breakdown');
    const label        = document.querySelector('.pp-booking-card-price-breakdown-label');

    if (titleEl)      titleEl.textContent  = '';
    if (priceEl)      priceEl.textContent  = '';
    if (optionEl)     optionEl.textContent = '';
    if (content)      content.classList.remove('active');
    if (breakdownBtn) breakdownBtn.classList.remove('is-visible', 'active');
    if (label)        label.textContent    = window.ppSection?.booking_breakdown_toggle_label || 'See the breakdown';
}

// ── Breakdown toggle ───────────────────────────────────────────────────────
function initPriceBreakdown() {
    const btn     = document.querySelector('.pp-booking-card-price-breakdown');
    const content = document.querySelector('.pp-booking-card-price-breakdown-content');
    const label   = document.querySelector('.pp-booking-card-price-breakdown-label');

    if (!btn || !content || !label) return;

    btn.addEventListener('click', function () {
        const isOpen = btn.classList.toggle('active');
        content.classList.toggle('active', isOpen);
        label.textContent = isOpen
            ? (window.ppSection?.booking_breakdown_hide  || 'Hide the breakdown')
            : (window.ppSection?.booking_breakdown_toggle_label || 'See the breakdown');
    });
}

// ── Sync branch state from current booking ────────────────────────────────
function syncBranchStateFromBooking() {
    const { startDate, endDate, locationData, locationGid } = currentBooking;

    let handle = null;
    if (locationGid && window.locationMetaobjects) {
        const incomingId = String(locationGid).replace('gid://shopify/Metaobject/', '');
        const match = Object.entries(window.locationMetaobjects).find(([, l]) => {
            return String(l.gid).replace('gid://shopify/Metaobject/', '') === incomingId;
        });
        if (match) handle = match[0];
    }

    branchState = {
        locationHandle: handle,
        startDate:      startDate || null,
        endDate:        endDate   || null,
    };

    document.querySelectorAll('.pp-booking-card-branch-location').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.location === handle);
    });

    if (startDate && endDate) {
        const totalNights = Math.round((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24));
        syncNightChip(totalNights);
    } else {
        document.querySelectorAll('.pp-booking-card-branch-night')
            .forEach(b => b.classList.remove('active'));
    }

    updateBranchInfo();
}

// ── Sync night chip by nights count ──────────────────────────────────────
function syncNightChip(nights) {
    document.querySelectorAll('.pp-booking-card-branch-night').forEach(btn => {
        let match = false;
        if (btn.dataset.nights === 'week')        match = nights > 3 && nights < 8;
        else if (btn.dataset.nights === 'month')  match = nights >= 8;
        else                                      match = parseInt(btn.dataset.nights, 10) === nights;
        btn.classList.toggle('active', match);
    });
}

// ── Update branch info text ───────────────────────────────────────────────
function updateBranchInfo() {
    const infoEl = document.querySelector('.pp-booking-card-branch-info');
    if (!infoEl) return;

    const { startDate, endDate } = branchState;

    if (startDate && endDate) {
        infoEl.textContent = `Pick up ${formatDate(startDate)} · return ${formatDate(endDate)}`;
    } else {
        infoEl.textContent = 'Real availability, unreal prices.';
    }
}

// ── Calc end date skipping closed days ────────────────────────────────────
function calcEndDate(startDate, chargeableNights) {
    const current = new Date(startDate);
    current.setDate(current.getDate() + chargeableNights);
    return current.toISOString().slice(0, 10);
}

/* computeNights / isClosedDay / getFreeLabel moved to assets/charged-nights.js
   One implementation, shared by this file, pp-product.js, collection-split.js and
   pb-cart.js, and matching snippets/charged-nights.liquid. Loaded in theme.liquid
   before this file, so the unqualified calls below resolve to it. Do not re-add a
   local copy. */

// ── Matrix mode ────────────────────────────────────────────────────────────
function initMatrixMode() {
    const select = document.querySelector('.pp-booking-card-mode-variant-options');
    const fromEl = document.querySelector('.pp-booking-card-price-from');
    if (!select) return;

    // ── Show default 1 night prices on load ───────────────────
    updateMatrixOptions(1);
    lastSelectedOption2 = select.options[select.selectedIndex]?.dataset.option2; // ← add

    // ── Dropdown change ────────────────────────────────────────
    select.addEventListener('change', function () {
        lastSelectedOption2 = this.options[this.selectedIndex]?.dataset.option2; // ← add first line
        const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
        const nights = hasBooking
            ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData).nightsCharged
            : 1;

        updateMatrixTopPrice(nights);

        // ── Toggle From based on first option ─────────────────
        const fromEl     = document.querySelector('.pp-booking-card-price-from');
        const isFirstOpt = this.selectedIndex === 0;
        if (fromEl) fromEl.style.display = isFirstOpt ? '' : 'none';

        if (hasBooking) {
            updatePDPPrice();
        } else {
            const productId = document.querySelector('[data-product-gid]')
                ?.dataset.productGid?.replace('gid://shopify/Product/', '');
            const data    = window.ppProductData?.[productId];
            const option2 = this.options[this.selectedIndex]?.dataset.option2;
            const option1 = getMatrixOption1(1, data?.variants || []);
            const variant = data?.variants?.find(v => v.option1 === option1 && v.option2 === option2);
            const priceEl = document.querySelector('.pp-booking-card-price');
            if (variant && priceEl) {
                [...priceEl.childNodes]
                    .filter(n => n.nodeType === Node.TEXT_NODE)
                    .forEach(n => n.remove());
                priceEl.appendChild(document.createTextNode(' ' + formatMoney(variant.price)));
            }
        }
    });
}

function updateMatrixOptions(nightsCharged) {
    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const option1 = getMatrixOption1(nightsCharged, data.variants);

    document.querySelectorAll('.pp-booking-card-mode-variant-options option').forEach(opt => {
        const option2 = opt.dataset.option2;
        const variant = data.variants.find(v =>
            v.option1 === option1 && v.option2 === option2
        );
        if (variant) {
            opt.value       = variant.id;
            opt.textContent = `${option2} · ${formatMoney(variant.price)}`;
        }
    });

    updateMatrixTopPrice(nightsCharged);
}

function updateMatrixTopPrice(nightsCharged) {
    const select  = document.querySelector('.pp-booking-card-mode-variant-options');
    const priceEl = document.querySelector('.pp-booking-card-mode-price');
    const titleEl = document.querySelector('.pp-booking-card-mode-selected-variant-title');
    if (!select || !priceEl) return;

    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const option1 = getMatrixOption1(nightsCharged, data.variants);
    const option2 = select.options[select.selectedIndex]?.dataset.option2;
    const variant = data.variants.find(v => v.option1 === option1 && v.option2 === option2);

    if (variant) {
      const area    = getAreaFromOption2(option2);
      const dims    = getDimsFromOption2(option2);
      const sqm     = parseInt(area);
      const panels  = sqm * 4;

      if (priceEl) priceEl.textContent = `${area} · ${formatMoney(variant.price)}`;
      if (titleEl) titleEl.textContent = `${dims} · ${area} · ${panels} panels`;
      updateMatrixGrid(option2);

      // ── Battery over threshold ─────────────────────────────
      const batteryEl = document.querySelector('.pp-booking-card-mode-battery');
      const bTitleEl  = document.querySelector('.pp-booking-card-mode-battery-title');
      const bSubEl    = document.querySelector('.pp-booking-card-mode-battery-subtitle');

      const threshold = window.ppSection?.power_threshold || 20;
      if (batteryEl) batteryEl.classList.toggle('is-over', sqm > threshold);

      if (sqm > threshold) {
          const note = (window.ppSection?.card_power_mains_note || '').replace('{limit}', `${threshold}m²`);
          if (bTitleEl) bTitleEl.textContent = window.ppSection?.card_power_mains || '';
          if (bSubEl)   bSubEl.textContent   = note;
      } else {
          const dims  = getDimsFromOption2(option2);
          const variant = data.variants.find(v => v.option1 === option1 && v.option2 === option2);
          const hours   = variant?.battery_runtime || 'some';
          const note    = (window.ppSection?.card_power_battery_note || '')
            ? (window.ppSection?.card_power_battery_note || '')
                .replace('{size}', dims)
                .replace('{area}', `${sqm}m²`)
                .replace('{hours}', hours)
            : '';
          if (bTitleEl) bTitleEl.textContent = window.ppSection?.card_power_battery || '';
          if (bSubEl)   bSubEl.textContent   = note;
      }
  }
}

function getAreaFromOption2(option2) {
    const match = option2.match(/\((\d+m²)\)/);
    return match ? match[1] : option2;
}

function getDimsFromOption2(option2) {
    // "2m x 2m (4m²)" → "2m × 2m"
    const match = option2.match(/^(\d+m)\s*x\s*(\d+m)/i);
    return match ? `${match[1]} x ${match[2]}` : option2;
}

// function getBatteryHours(sqm) {
//     const bands = window.ppSection?.battery_runtime_bands;
//     const parsed = bands
//         .map(b => {
//             const [square, hours] = b.split(':');
//             return { square: parseInt(square), hours };
//         })
//         .sort((a, b) => a.square - b.square);

//     const match = parsed.find(b => sqm <= b.square);
//     return match ? match.hours : parsed[parsed.length - 1].hours;
// }

function getMatrixOption1(nightsCharged, variants) {
    const option1s = [...new Set(variants.map(v => v.option1))];

    for (const opt of option1s) {
        const label = opt.toLowerCase().trim();

        const singleMatch = label.match(/^(\d+)\s+night/);
        if (singleMatch) {
            if (nightsCharged === parseInt(singleMatch[1])) return opt;
        }

        const rangeMatch = label.match(/^(\d+)-(\d+)\s+night/);
        if (rangeMatch) {
            const from = parseInt(rangeMatch[1]);
            const to   = parseInt(rangeMatch[2]);
            if (nightsCharged >= from && nightsCharged <= to) return opt;
        }

        if (label.includes('week')  && nightsCharged >= 4 && nightsCharged <= 7) return opt;
        if (label.includes('month') && nightsCharged >= 8) return opt;
    }

    return option1s[option1s.length - 1];
}

function updateMatrixGrid(option2) {
    const imgEl = document.querySelector('.pp-booking-card-mode-selected-variant-img');
    if (!imgEl) return;

    const match = option2.match(/^(\d+)m\s*x\s*(\d+)m/i);
    if (!match) return;

    const widthM  = parseInt(match[1]);
    const heightM = parseInt(match[2]);
    const cols    = widthM  * 2;
    const rows    = heightM * 2;
    const total   = cols * rows;

    imgEl.innerHTML = '';
    imgEl.style.width                = `${widthM * 14}px`;
    imgEl.style.aspectRatio          = `${widthM} / ${heightM}`;
    imgEl.style.gridTemplateColumns  = `repeat(${cols}, 1fr)`;
    imgEl.style.gridTemplateRows     = `repeat(${rows}, 1fr)`;

    for (let i = 0; i < total; i++) {
        const row    = Math.floor(i / cols);
        const col    = i % cols;
        const isDark = (row + col) % 2 === 0;
        const span   = document.createElement('span');
        span.className = isDark ? 'panel-piece1' : 'panel-piece2';
        imgEl.appendChild(span);
    }
}

// ── Per unit mode ──────────────────────────────────────────────────────────

function initPerUnitMode() {
    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data) return;

    const minBtn       = document.querySelector('.pp-bcm-qty-min');
    const plusBtn      = document.querySelector('.pp-bcm-qty-plus');
    const valueEl      = document.querySelector('.pp-bcm-qty-value');
    const presetsEl    = document.querySelector('.pp-bcm-qty-presets-container');
    const presetBtnsEl = document.querySelector('.pp-bcm-qty-presets-btns');
    const guidanceEl   = document.querySelector('.pp-bcm-qty-guidance');

    if (!valueEl) return;

    const qtyMin  = parseInt(data.qtyMin)  || 1;
    const qtyMax  = parseInt(data.qtyMax)  || 999;
    const qtyStep = parseInt(data.qtyStep) || 1;

    // ── Set initial value ──────────────────────────────────────
    currentQty = qtyMin;
    valueEl.textContent = currentQty;
    updateQtyButtons(currentQty, qtyMin, qtyMax, minBtn, plusBtn);
    updateGuidance(currentQty, data, guidanceEl);

    // ── Presets ────────────────────────────────────────────────
    if (data.qtyPresets && presetsEl && presetBtnsEl) {
        const presets = data.qtyPresets.split(',').map(p => parseInt(p.trim())).filter(Boolean);
        if (presets.length) {
            presetsEl.style.display = '';
            presetBtnsEl.innerHTML = '';
            presets.forEach(preset => {
                const btn = document.createElement('button');
                btn.className = 'pp-bcm-qty-presets-btn';
                btn.textContent = preset;
                if (preset === currentQty) btn.classList.add('is-selected');
                btn.addEventListener('click', function () {
                    currentQty = preset;
                    valueEl.textContent = currentQty;
                    updateQtyButtons(currentQty, qtyMin, qtyMax, minBtn, plusBtn);
                    updateGuidance(currentQty, data, guidanceEl);
                    document.querySelectorAll('.pp-bcm-qty-presets-btn')
                        .forEach(b => b.classList.remove('is-selected'));
                    this.classList.add('is-selected');
                    updatePerUnitPriceFromSelected(); // ← add
                });
                presetBtnsEl.appendChild(btn);
            });
        } else {
            presetsEl.style.display = 'none';
        }
    } else if (presetsEl) {
        presetsEl.style.display = 'none';
    }

    // ── Plus ───────────────────────────────────────────────────
    if (plusBtn) {
        plusBtn.addEventListener('click', function () {
            if (currentQty + qtyStep > qtyMax) return;
            currentQty += qtyStep;
            valueEl.textContent = currentQty;
            updateQtyButtons(currentQty, qtyMin, qtyMax, minBtn, plusBtn);
            updateGuidance(currentQty, data, guidanceEl);
            syncPresetSelection(currentQty);
            updatePerUnitPriceFromSelected(); // ← add
        });
    }

    // ── Min ────────────────────────────────────────────────────
    if (minBtn) {
        minBtn.addEventListener('click', function () {
            if (currentQty - qtyStep < qtyMin) return;
            currentQty -= qtyStep;
            valueEl.textContent = currentQty;
            updateQtyButtons(currentQty, qtyMin, qtyMax, minBtn, plusBtn);
            updateGuidance(currentQty, data, guidanceEl);
            syncPresetSelection(currentQty);
            updatePerUnitPriceFromSelected(); // ← add
        });
    }

    // ── Set initial price ──────────────────────────────────────
    updatePerUnitPriceFromSelected();
    updateRowPrices();
}

function updatePerUnitPrice(qty) {
    const priceEl = document.querySelector('.pp-perunit-price');
    if (!priceEl) return;

    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const { nightsCharged } = (currentBooking.startDate && currentBooking.endDate && currentBooking.locationData)
        ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
        : { nightsCharged: 1 };

    const option1 = getMatrixOption1(nightsCharged, data.variants);
    const variant = data.variants.find(v => v.option1 === option1);

    if (variant) {
        priceEl.textContent = `${formatMoney(variant.price)}`;
    }
}

function initPerUnitVariants() {
    // ── Button click ───────────────────────────────────────────
    document.querySelectorAll('.pp-bcm-variant').forEach(btn => {
        btn.addEventListener('click', function () {
            // ── Remove is-selected from same option group ──────
            const optionIndex = this.dataset.optionIndex;
            document.querySelectorAll(`.pp-bcm-variant[data-option-index="${optionIndex}"]`)
                .forEach(b => b.classList.remove('is-selected'));
            this.classList.add('is-selected');

            // ── Update price ───────────────────────────────────
            updatePerUnitPriceFromSelected();
            updateRowPrices();
            updateCapacitySecondOptionPrices();
            updateBookingGates();
            updateCableKit();
            updateSetupTime();
        });
    });

    // ── Dropdown change ────────────────────────────────────────
    document.addEventListener('change', function (e) {
        const select = e.target.closest('.pp-bcm-variant-select');
        if (!select) return;

        updatePerUnitPriceFromSelected();
        updateRowPrices();
        updateBookingGates();
    });

    // ── Matrix select change ───────────────────────────────
    document.querySelector('.pp-booking-card-mode-variant-options')
        ?.addEventListener('change', function () {
            updateBookingGates();
        });
}

function updateCapacitySecondOptionPrices() {
    if (window.ppSection?.booking_card_mode !== 'capacity') return;

    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
    const { nightsCharged } = hasBooking
        ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
        : { nightsCharged: 1 };

    const option1 = getMatrixOption1(nightsCharged, data.variants);

    // Get selected value from first container
    const firstContainer  = document.querySelector('.pp-bcm-variant-container');
    const selectedBtn     = firstContainer?.querySelector('.pp-bcm-variant.is-selected');
    if (!selectedBtn) return;

    const selectedOption2 = selectedBtn.dataset.value;

    // Update second container prices relative to selected first option
    document.querySelectorAll('.pp-bcm-variant-container').forEach((container, containerIndex) => {
        if (containerIndex === 0) return; // skip first container

        const optionIndex = parseInt(container.dataset.optionIndex);
        const buttons     = container.querySelectorAll('.pp-bcm-variant');
        if (!buttons.length) return;

        // Base price = first button's variant with selected option2
        const firstBtnVal = buttons[0].dataset.value;
        const baseVariant = data.variants.find(v =>
            v.option1 === option1 &&
            v.option2 === selectedOption2 &&
            v[`option${optionIndex + 1}`] === firstBtnVal
        );
        const basePrice = baseVariant?.price ?? null;

        buttons.forEach((btn, i) => {
            const rowPriceEl   = btn.querySelector('.pp-bcm-variant-row-price');
            const firstPriceEl = btn.querySelector('.pp-bcm-variant-row-price-first');
            const btnVal       = btn.dataset.value;

            if (i === 0) {
                if (firstPriceEl) { const incEl = btn.closest('.pp-bcm-variant-container'); const inc = incEl && incEl.dataset.included != null ? incEl.dataset.included : '$0'; firstPriceEl.textContent = inc; firstPriceEl.hidden = !inc.trim(); } /* 324: First value says (empty = nothing) */
                return;
            }

            if (!rowPriceEl || basePrice === null) return;

            const btnVariant = data.variants.find(v =>
                v.option1 === option1 &&
                v.option2 === selectedOption2 &&
                v[`option${optionIndex + 1}`] === btnVal
            );

            if (btnVariant) {
                const diff = btnVariant.price - basePrice;
                rowPriceEl.textContent = diff > 0 ? `+${formatMoney(diff)}` : '$0';
            }
        });
    });
}

function updateRowPrices() {
    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
    const { nightsCharged } = hasBooking
        ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
        : { nightsCharged: 1 };

    const option1 = getMatrixOption1(nightsCharged, data.variants);
    const isCapacity = window.ppSection?.booking_card_mode === 'capacity';

    // ── Update dropdown options ────────────────────────────────
    document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
        const optionIndex = parseInt(select.dataset.optionIndex);
        const currentVal  = select.options[select.selectedIndex]?.dataset.value;

        // Find base price (first option value) for this hire period
        const firstOpt     = select.options[0];
        const firstVal     = firstOpt?.dataset.value;
        const baseVariant  = data.variants.find(v =>
            v.option1 === option1 && v[`option${optionIndex + 1}`] === firstVal
        );
        const basePrice = baseVariant?.price ?? null;

        [...select.options].forEach((opt, i) => {
            const val     = opt.dataset.value;
            const variant = data.variants.find(v =>
                v.option1 === option1 && v[`option${optionIndex + 1}`] === val
            );
            if (!variant) return;

            const label = val.split(' (')[0];
            if (i === 0) {
                opt.textContent = label;
            } else {
                const diff = basePrice !== null ? variant.price - basePrice : 0;
                opt.textContent = diff > 0
                    ? `${label} · +${formatMoney(diff)}`
                    : label;
            }
        });

        // Restore selected value
        if (currentVal) {
            const target = [...select.options].find(o => o.dataset.value === currentVal);
            if (target) select.value = target.value;
        }
    });

    // ── Update row/chip button prices ─────────────────────────
    document.querySelectorAll('.pp-bcm-variant-container').forEach((container, containerIndex) => {
        const optionIndex = parseInt(container.dataset.optionIndex);
        const buttons     = container.querySelectorAll('.pp-bcm-variant');
        if (!buttons.length) return;

        const firstVal    = buttons[0].dataset.value;
        const baseVariant = data.variants.find(v =>
            v.option1 === option1 && v[`option${optionIndex + 1}`] === firstVal
        );
        const basePrice = baseVariant?.price ?? null;

        buttons.forEach((btn, i) => {
            const rowPriceEl   = btn.querySelector('.pp-bcm-variant-row-price');
            const firstPriceEl = btn.querySelector('.pp-bcm-variant-row-price-first');
            const btnVal       = btn.dataset.value;
            const priceEl      = rowPriceEl || firstPriceEl;

            if (isCapacity && containerIndex === 0) {
                // ── First container: show absolute cheapest price ──
                const cheapest = data.variants
                    .filter(v => v.option1 === option1 && v[`option${optionIndex + 1}`] === btnVal)
                    .sort((a, b) => a.price - b.price)[0];
                if (priceEl && cheapest) {
                    priceEl.textContent = formatMoney(cheapest.price);
                }
            } else {
                // ── Other containers: show diff ────────────────────
                if (i === 0) {
                    if (firstPriceEl) { const incEl = btn.closest('.pp-bcm-variant-container'); const inc = incEl && incEl.dataset.included != null ? incEl.dataset.included : '$0'; firstPriceEl.textContent = inc; firstPriceEl.hidden = !inc.trim(); } /* 324: First value says (empty = nothing) */
                    return;
                }
                if (!rowPriceEl || basePrice === null) return;
                const btnVariant = data.variants.find(v =>
                    v.option1 === option1 && v[`option${optionIndex + 1}`] === btnVal
                );
                if (btnVariant) {
                    const diff = btnVariant.price - basePrice;
                    rowPriceEl.textContent = diff > 0 ? `+${formatMoney(diff)}` : '$0';
                }
            }
        });
    });
}

function updateQtyButtons(qty, min, max, minBtn, plusBtn) {
    if (minBtn)  minBtn.classList.toggle('is-disable', qty <= min);
    if (plusBtn) plusBtn.classList.toggle('is-disable', qty >= max);
}

function updateGuidance(qty, data, guidanceEl) {
    if (!guidanceEl) return;

    const hasPresets = data.qtyPresets && data.qtyPresets.trim() !== '';

    if (hasPresets && Array.isArray(data.qtyGuidance) && data.qtyGuidance.length) {
        const parsed = data.qtyGuidance.map(g => {
            const idx  = g.indexOf(':');
            return { qty: parseInt(g.slice(0, idx)), text: g.slice(idx + 1).trim() };
        }).sort((a, b) => b.qty - a.qty);

        const match = parsed.find(g => g.qty <= qty);
        if (match) {
            guidanceEl.textContent = match.text;
            guidanceEl.style.display = '';
            return;
        }
    }

    // Fallback
    if (data.qtyGuidanceFallback) {
        guidanceEl.textContent = data.qtyGuidanceFallback.replace('{span}', qty);
        guidanceEl.style.display = '';
    } else {
        guidanceEl.style.display = 'none';
    }
}

function syncPresetSelection(qty) {
    document.querySelectorAll('.pp-bcm-qty-presets-btn').forEach(btn => {
        btn.classList.toggle('is-selected', parseInt(btn.textContent) === qty);
    });
}

function updatePerUnitPriceFromSelected() {
    const priceEl   = document.querySelector('.pp-perunit-price');
    const mainPrice = document.querySelector('.pp-booking-card-price');

    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
    const { nightsCharged } = hasBooking
        ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
        : { nightsCharged: 1 };

    const option1 = getMatrixOption1(nightsCharged, data.variants);

    // ── Collect selected values ────────────────────────────────
    const selectedValues = {};

    // From buttons
    document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(btn => {
        const idx = parseInt(btn.dataset.optionIndex);
        selectedValues[idx] = btn.dataset.value;
    });

    // From dropdowns
    document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
        const idx = parseInt(select.dataset.optionIndex);
        const selectedOpt = select.options[select.selectedIndex];
        if (selectedOpt) selectedValues[idx] = selectedOpt.dataset.value;
    });

    /*  422 (Ben 14-10-2026: "qty adjustment needs to update price"): two early exits
        left the Hire total frozen when the quantity changed.
        1. A product with a quantity but no other options has nothing selected, so the
           old guard returned before the total was worked out. It now uses the hire
           period's variant.
        2. When the picked values matched no variant exactly (a look that renders its
           choices differently, or a value not on that hire period), it returned. It now
           takes the variant on this hire period matching the most picked values. */
    const sameHire = data.variants.filter(v => v.option1 === option1);
    if (!sameHire.length) return;
    const picks = Object.entries(selectedValues);
    let variant = sameHire.find(v => picks.every(([idx, val]) => v[`option${parseInt(idx) + 1}`] === val));
    if (!variant) {
        let best = -1;
        sameHire.forEach(v => {
            const score = picks.filter(([idx, val]) => v[`option${parseInt(idx) + 1}`] === val).length;
            if (score > best) { best = score; variant = v; }
        });
    }
    if (!variant) return;

    // ── Update breakdown ───────────────────────────────────────
    updatePDPBreakdown(variant.price, nightsCharged);

    // ── Per unit price ─────────────────────────────────────────
    if (priceEl) {
        priceEl.textContent = `${formatMoney(variant.price)}`;
    }

    // ── Total price with qty ───────────────────────────────────
    const total = variant.price * currentQty;
    const fromEl  = document.querySelector('.pp-booking-card-price-from');

    if (mainPrice) {
        [...mainPrice.childNodes]
            .filter(n => n.nodeType === Node.TEXT_NODE)
            .forEach(n => n.remove());

        if (hasBooking) {
            if (fromEl) fromEl.style.display = 'none';
            mainPrice.appendChild(document.createTextNode(' ' + formatMoney(variant.price * currentQty)));
        } else {
            if (fromEl) fromEl.style.display = '';
            mainPrice.appendChild(document.createTextNode(' ' + formatMoney(variant.price * currentQty)));
        }
    }

    // ── Unit label from product title ──────────────────────────
    const productTitle = (document.querySelector('[data-product-title]')?.dataset.productTitle || '').toLowerCase();
    const unitLabel = productTitle.includes('light') ? 'lights'
        : productTitle.includes('ball')  ? 'balls'
        : 'units';

    // ── For nights ─────────────────────────────────────────────
    const forNightsEl = document.querySelector('.pp-booking-card-price-for-nights');
    const isPerUnit = window.ppSection?.booking_card_mode === 'perUnit';
    if (forNightsEl) {
        if (hasBooking) {
            const totalNights = Math.round((new Date(currentBooking.endDate) - new Date(currentBooking.startDate)) / (1000 * 60 * 60 * 24));
            let nightsText = window.djwNightsHTML(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData);   /* 577 */
            if (isPerUnit) {
                const productTitle = (document.querySelector('[data-product-title]')?.dataset.productTitle || '').toLowerCase();
                const unitLabel = productTitle.includes('light') ? 'lights'
                    : productTitle.includes('ball') ? 'balls'
                    : 'units';
                nightsText += ` · ${currentQty} ${unitLabel}`;
            }
            forNightsEl.innerHTML = nightsText;
        } else {
            forNightsEl.textContent = '';
        }
    }
}

/* ─────────────────────────────────────────────────────────────
   SETUP TIME — update from selected variant
───────────────────────────────────────────────────────────────*/
function updateSetupTime() {
    const container = document.querySelector('[data-setup-time]');
    if (!container) return;

    const titleEl = container.querySelector('[data-setup-time-title]');
    const subEl   = container.querySelector('[data-setup-time-sub]');

    const productId = document.querySelector('[data-product-gid]')
        ?.dataset.productGid?.replace('gid://shopify/Product/', '');
    const data = window.ppProductData?.[productId];
    if (!data?.variants?.length) return;

    const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
    const { nightsCharged } = hasBooking
        ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
        : { nightsCharged: 1 };

    const option1 = getMatrixOption1(nightsCharged, data.variants);

    // ── Get selected variant ───────────────────────────────
    const selectedValues = {};
    document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(btn => {
        selectedValues[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
    });
    document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
        const opt = select.options[select.selectedIndex];
        if (opt) selectedValues[parseInt(select.dataset.optionIndex)] = opt.dataset.value;
    });

    const variant = data.variants.find(v => {
        if (v.option1 !== option1) return false;
        return Object.entries(selectedValues).every(([idx, val]) =>
            v[`option${parseInt(idx) + 1}`] === val
        );
    });

    // ── Resolution order: variant → product fallback ───────
    const st = variant?.setup_time || window.ppProductData?.[productId]?.setup_time_base;
    if (!st) {
        container.style.display = 'none';
        return;
    }

    container.style.display = '';

    const min    = st.min    || 0;
    const max    = st.max    || 0;
    let people   = st.people || 1;
    if (people === 0) people = 1;
    const sub    = st.sub    || '';

    const peopleWords = ['One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten'];
    const peopleLabel = peopleWords[people - 1] || people;
    const personWord  = people === 1 ? 'person' : 'people';

    let timeStr = '';
    if (min > 0 && max > 0) timeStr = `, ${min}-${max} minutes`;
    else if (min > 0)        timeStr = `, ${min} minutes`;
    else if (max > 0)        timeStr = `, ${max} minutes`;

    if (titleEl) titleEl.textContent = `${peopleLabel} ${personWord}${timeStr} to set up`;

    if (subEl) {
        subEl.textContent    = sub;
        subEl.style.display  = sub ? '' : 'none';
    }
}

/* ── Update booking gates ─────────────────────────────────────
   Re-renders gates based on currently selected variant
   options. Gates with no when_option_value always show.   */
function updateBookingGates() {
    const gatesContainer = document.querySelector('.pp-booking-card-gates');
    if (!gatesContainer) return;

    const allGates = window.ppBookingGates || [];
    if (!allGates.length) return;

    // ── Get current selected options ───────────────────────
    const selectedOptions = [];

    // From tile/chip/row/graphic buttons
    document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(btn => {
        selectedOptions.push(btn.dataset.value);
    });

    // From dropdown selects (perunit/package mode)
    document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
        const opt = select.options[select.selectedIndex];
        if (opt) selectedOptions.push(opt.dataset.value);
    });

    // From matrix mode select
    const matrixSelect = document.querySelector('.pp-booking-card-mode-variant-options');
    if (matrixSelect) {
        const opt = matrixSelect.options[matrixSelect.selectedIndex];
        if (opt) selectedOptions.push(opt.dataset.option2);
    }

    // ── Filter and render ──────────────────────────────────
    gatesContainer.querySelectorAll('.pp-booking-card-gate').forEach(el => el.remove());
    allGates.forEach(gate => {
        const show = !gate.when_option_value ||
            gate.when_option_value.split(',').map(v => v.trim()).some(v =>
                selectedOptions.some(opt => opt === v)
            );

        if (show && gate.text) {
            const btn     = document.createElement('button');
            btn.className = 'pp-booking-card-gate';
            btn.type      = 'button';
            btn.innerHTML = `
                <span class="pp-booking-card-checkbox">✓</span>
                <span class="pp-booking-card-gate-label">${gate.text}</span>
            `;
            gatesContainer.prepend(btn);
        }
    });

    // ── Re-init gate count for CTA validation ─────────────
    if (typeof window.updateCTAState === 'function') window.updateCTAState();
}


/* ─────────────────────────────────────────────────────────────
   PP-BOOKING Button
───────────────────────────────────────────────────────────────*/
/*  The panel heading was drawn here, with a long note on why it counts nothing. Both
    moved to sections/booking-panel.liquid, which renders the heading now and carries
    that reasoning.

    It read "are there rows left?" off the DOM to decide whether to hide the panel.
    booking-row.js asks the same question of the freshly rendered HTML, for the same
    reason: no tally can drift out of step with what is on screen. */

/* ── Tell the customer the add did not happen ───────────────────────────────────
   Sits under the add-to-cart button. Before this, a refused add wrote to the console and
   stopped: the card carried on as though it had worked, the number on screen stayed at
   what was asked for, and the cart quietly held something else. The customer found out
   at checkout, or not at all.

   Shopify's own sentence is shown where there is one. It is plain enough to use as-is,
   and writing our own wording would mean guessing at causes we do not control. */
function pdpAddError(message) {
    const anchor = document.querySelector('.pp-booking-card-btn')
        || document.querySelector('.pp-booking-card-available')
        || document.querySelector('.pp-booking-card');
    if (!anchor) { console.warn('No anchor for add error:', message); return; }

    let el = document.querySelector('.pp-add-error');
    if (!el) {
        el = document.createElement('p');
        el.className = 'pp-add-error';
        el.setAttribute('role', 'alert');
        anchor.insertAdjacentElement('afterend', el);
    }

    el.textContent = message;
    el.classList.add('is-visible');
}

function pdpClearAddError() {
    const el = document.querySelector('.pp-add-error');
    if (el) el.classList.remove('is-visible');
}

async function addToCartRequest(variantId, quantity, properties) {
    pdpClearAddError();

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: quantity,
                properties: properties
            }]
        })
    });
    /* Keep Shopify's reason. This used to throw a bare 'Cart add failed', which the
       caller logged and nothing else — so a refused add looked to the customer exactly
       like a successful one.

       Shopify's 422 body carries a plain-English `description`, e.g. "Only 100 items
       were added to your cart due to availability." That sentence is the only thing
       that tells anyone what happened, so it travels with the error. */
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        const err = new Error((body && body.description) || 'Cart add failed');
        err.shopifyDescription = body && body.description;
        err.status = response.status;
        throw err;
    }
    return response.json();
}

/* ─────────────────────────────────────────────────────────────
   CABLE KIT — update subtitle from selected option
───────────────────────────────────────────────────────────────*/
function updateCableKit() {
    const subtitleEl = document.querySelector('[data-cable-kit-subtitle]');
    const codeEl     = document.querySelector('[data-cable-kit-code]');
    if (!subtitleEl) return;

    const code          = window.cableKitCode;
    const perUnit       = window.cableKitsPerUnit || 0;
    const byOption      = window.cableKitsByOption || [];

    if (!code) return;

    // ── Get selected option value ──────────────────────────
    const selectedBtn = document.querySelector('.pp-bcm-variant.is-selected');
    const selectedVal = selectedBtn?.dataset.value || null;

    // ── Resolution order ───────────────────────────────────
    let kitCount = perUnit; // fallback

    if (selectedVal && byOption.length) {
        const match = byOption.find(row => row.option_value === selectedVal);
        if (match) kitCount = match.kit_count;
    }

    // ── Update data attribute ──────────────────────────────
    if (codeEl) codeEl.dataset.cableKitCode = `${code} x ${kitCount}`;

    // ── Update subtitle ────────────────────────────────────
    if (kitCount === 1) {
        subtitleEl.textContent = '1 x RCA and 1 x TRS, packed with the gear';
    } else {
        subtitleEl.textContent = `${kitCount} kits packed with every one you hire — 1 x RCA and 1 x TRS each`;
    }
}

/*  ── THE TWO-STEP ADD ────────────────────────────────────────────────────────
    "Add another" used to do two jobs in one press: add the item AND clear the
    options for the next one. Two consequences, both bad.

    The label never described the press. And the clearing happened at the exact
    moment the cart drawer was opening, so the customer's attention was in the
    drawer while the card silently rearranged itself behind it.

    It is now a mode switch, and every label describes what pressing it does:

      1. "Add to booking"  adds the item. The cart drawer opens — that IS the
                           confirmation, so no other cue is needed.
      2. "Add another"     (hollow) clears the options, scrolls back to the top of
                           the card, and turns itself back into "Add to booking".
                           It adds nothing.

    So the button that adds always says "Add to booking", and the scroll happens
    when the customer has asked for a new item rather than while they are reading
    the drawer.

    awaitingNewItem is module-scoped because updateCTAState lives inside
    initBookingCardCTA and both need to read it.
*/
let awaitingNewItem = false;

/*  Clear the options so the next add is a genuinely different item.

    Resets — option groups, the matrix selection, and quantity back to the
    product's minimum. These describe the item.

    Keeps — location, dates, and the terms checkboxes. Location and dates belong to
    the booking rather than the item, which is what the card's own note promises.
    The gates accept hire terms for the booking; re-ticking per item would be worse
    and would not mean anything different.

    Selects get a dispatched 'change' so the existing handlers do the recalculating
    instead of this function duplicating it.
*/
function resetCardOptions() {
    try {
        document.querySelectorAll('.pp-bcm-variant-box').forEach((box) => {
            const buttons = box.querySelectorAll('.pp-bcm-variant');
            if (!buttons.length) return;
            buttons.forEach((b) => b.classList.remove('is-selected'));
            buttons[0].classList.add('is-selected');
        });

        document.querySelectorAll('.pp-bcm-variant-select, .pp-booking-card-mode-variant-options').forEach((sel) => {
            if (!sel.options.length || sel.selectedIndex === 0) return;
            sel.selectedIndex = 0;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
        });

        const valueEl = document.querySelector('.pp-bcm-qty-value');
        if (valueEl) {
            const productId = document.querySelector('[data-product-gid]')
                ?.dataset.productGid?.replace('gid://shopify/Product/', '');
            const data   = window.ppProductData?.[productId];
            const qtyMin = parseInt(data?.qtyMin) || 1;
            const qtyMax = parseInt(data?.qtyMax) || 999;

            currentQty = qtyMin;
            valueEl.textContent = currentQty;

            if (typeof updateQtyButtons === 'function') {
                updateQtyButtons(currentQty, qtyMin, qtyMax,
                    document.querySelector('.pp-bcm-qty-min'),
                    document.querySelector('.pp-bcm-qty-plus'));
            }
            if (typeof updateGuidance === 'function') {
                updateGuidance(currentQty, data, document.querySelector('.pp-bcm-qty-guidance'));
            }
            if (typeof syncPresetSelection === 'function') {
                syncPresetSelection(currentQty);
            }
        }

        if (typeof updatePerUnitPriceFromSelected === 'function') {
            updatePerUnitPriceFromSelected();
        }
    } catch (err) {
        console.error('resetCardOptions error:', err.message);
    }
}

/*  Bring the top of the card into view.

    Not scrollIntoView: the sticky header and booking bar overlay the top of the
    viewport, so the target has to be offset by their real heights or the options
    land underneath them. --header-height is the value header.js sets — the one that
    was never being set at all until the null guards went in.
*/
function scrollToCardTop() {
    const card = document.querySelector('.pp-booking-card');
    if (!card) return;

    const cs      = getComputedStyle(document.documentElement);
    const headerH = parseInt(cs.getPropertyValue('--header-height')) || 0;
    const barEl   = document.querySelector('.booking-bar');
    const barH    = barEl ? barEl.getBoundingClientRect().height : 0;

    window.scrollTo({
        top: Math.max(0, card.getBoundingClientRect().top + window.pageYOffset - headerH - barH - 16),
        behavior: 'smooth'
    });
}

/*  Step 2. Adds nothing — it prepares the card and hands the button back. */
function startNewItem() {
    awaitingNewItem = false;
    resetCardOptions();
    scrollToCardTop();
    if (typeof window.updateCTAState === 'function') window.updateCTAState();
}

function addToBooking() {
    try {
        /* ── The confirmation panel is rendered by Liquid now ────────────────────
           It used to be built here, element by element, from a variant label and a
           price string read off the card. That is why it vanished on navigation, and
           why its row could say "8 ×" while the cart said something else: it was a
           second implementation of a row that already existed in
           snippets/booking-row.liquid.

           The panel is sections/booking-panel.liquid — the same shared row the cart
           page uses, at compact density, read from cart.items. Rendered inline on load
           and refreshed by window.BookingRow.refreshPanels() after this add.

           So nothing below draws a row, a heading, a price or a Remove button. The
           quantity that was formatted into the row went with it; the row reads its own
           quantity off the cart line.

           variantLabel below is still built, for the _variant_label line property.
           It is not read by the row.

           priceText went with _price on 11-09-2026 (#86). It scraped the rendered
           .pp-booking-card-price element and existed for nothing else, so it came out
           with the property — see the note at the properties block below.

           The panel element is not looked up here at all any more. It used to be, and
           a missing panel returned early out of this whole function — so a card
           without one could not add to the booking either. */

        // ── Mode flags ─────────────────────────────────────────
        const isMatrix   = window.ppSection?.booking_card_mode === 'matrix';
        const isPerUnit  = window.ppSection?.booking_card_mode === 'perUnit';
        const isPackage  = window.ppSection?.booking_card_mode === 'package';
        const isCapacity = window.ppSection?.booking_card_mode === 'capacity';

        // ── Product data ───────────────────────────────────────
        const productId = document.querySelector('[data-product-gid]')
            ?.dataset.productGid?.replace('gid://shopify/Product/', '');
        const data = window.ppProductData?.[productId];

        const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
        const { nightsCharged } = hasBooking
            ? computeNights(currentBooking.startDate, currentBooking.endDate, currentBooking.locationData)
            : { nightsCharged: 1 };

        const option1 = getMatrixOption1(nightsCharged, data?.variants || []);

        // ── Get variant label ──────────────────────────────────
        let variantLabel = '';
        let variantId    = null;

        if (isMatrix) {
            const matrixSelect = document.querySelector('.pp-booking-card-mode-variant-options');
            const selectedOpt  = matrixSelect?.options[matrixSelect.selectedIndex];
            if (selectedOpt) {
                variantLabel = (selectedOpt.dataset.option2 || '').split(' (')[0];
                variantId    = parseInt(matrixSelect.value);
            }

        } else if (isPerUnit || isPackage || isCapacity) {
            const productTitle = document.querySelector('[data-product-title]')?.dataset.productTitle || '';
            const titleLower   = productTitle.toLowerCase();
            const unitLabel    = titleLower.includes('light') ? 'lights'
                : titleLower.includes('ball') ? 'balls'
                : 'units';

            const parts = isPerUnit ? [`${currentQty} × ${unitLabel}`] : [];

            // ── Collect selected values for variant find ───────
            const selectedValues = {};
            document.querySelectorAll('.pp-bcm-variant-box').forEach((box, boxIndex) => {
                const buttons     = box.querySelectorAll('.pp-bcm-variant');
                const selectedBtn = box.querySelector('.pp-bcm-variant.is-selected');
                if (!selectedBtn) return;

                selectedValues[parseInt(selectedBtn.dataset.optionIndex)] = selectedBtn.dataset.value;

                if (isCapacity && boxIndex === 0) {
                    parts.push(selectedBtn.dataset.value.split(' (')[0]);
                } else if (selectedBtn === buttons[0]) {
                    return;
                } else {
                    parts.push(selectedBtn.dataset.value.split(' (')[0]);
                }
            });

            document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
                const selectedOpt = select.options[select.selectedIndex];
                const firstOpt    = select.options[0];
                if (!selectedOpt || !firstOpt) return;
                selectedValues[parseInt(select.dataset.optionIndex)] = selectedOpt.dataset.value;
                if (selectedOpt.value === firstOpt.value) return;
                parts.push(selectedOpt.dataset.value.split(' (')[0]);
            });

            if (isPerUnit) {
                variantLabel = parts.join(' · ');
            } else {
                const hasNonDefault = parts.length > 0;
                variantLabel = hasNonDefault ? parts.join(' · ') : productTitle;
            }

            // ── Find variant ID ────────────────────────────────
            const variant = data?.variants?.find(v => {
                if (v.option1 !== option1) return false;
                return Object.entries(selectedValues).every(([idx, val]) =>
                    v[`option${parseInt(idx) + 1}`] === val
                );
            });
            variantId = variant?.id || null;

        } else {
            const variantParts = [];
            const selectedValues = {};
            document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(btn => {
                variantParts.push(btn.dataset.value.split(' (')[0]);
                selectedValues[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
            });
            document.querySelectorAll('.pp-bcm-variant-select').forEach(select => {
                const selectedOpt = select.options[select.selectedIndex];
                if (selectedOpt) {
                    variantParts.push(selectedOpt.dataset.value.split(' (')[0]);
                    selectedValues[parseInt(select.dataset.optionIndex)] = selectedOpt.dataset.value;
                }
            });
            variantLabel = variantParts.join(' · ');

            const variant = data?.variants?.find(v => {
                if (v.option1 !== option1) return false;
                return Object.entries(selectedValues).every(([idx, val]) =>
                    v[`option${parseInt(idx) + 1}`] === val
                );
            });
            variantId = variant?.id || null;
        }

        /* The row, the heading and the note all live in the panel section now, and
           card_added_note is read there. */

        // ── Add to cart ────────────────────────────────────────
        /* ── #65, FIXED HERE 11-09-2026 ────────────────────────────────────────────
           The second getLocationHours() lived here, and unlike the other four it
           NEVER STRIPPED THE WEEKDAY PREFIX. Its output went straight onto the order
           at the attributes block below, so adding to cart from a product page
           stamped "Mon 8am – 3pm" as 'Pick up time' while the booking bar and the
           cart page stamped "8am – 3pm" for the very same booking. Order data
           differed by which button the customer pressed.

           Both are gone. window.hoursFor is the one parser, and it applies Special
           Trading Date overrides too (#64). */

        if (variantId) {
            const pickupTime = window.hoursFor(currentBooking.startDate, currentBooking.locationData, 'pickup');
            const returnTime = window.hoursFor(currentBooking.endDate,   currentBooking.locationData, 'return');

            // ── Cable kit property ─────────────────────────────
            const code     = window.cableKitCode;
            const byOption = window.cableKitsByOption || [];
            const perUnit  = window.cableKitsPerUnit  || 0;

            const selectedBtn = document.querySelector('.pp-bcm-variant.is-selected');
            const selectedVal = selectedBtn?.dataset.value || null;
            let kitCount = perUnit;
            if (selectedVal && byOption.length) {
                const match = byOption.find(row => row.option_value === selectedVal);
                if (match) kitCount = match.kit_count;
            }

            /*  ── #86: `_price` IS GONE FROM LINE-ITEM PROPERTIES — 11-09-2026 ───────
                Adding the same product and options twice produced two lines of quantity
                1 instead of one line of quantity 2. Shopify merges a line only when the
                variant id AND EVERY PROPERTY match, and `/cart.js` showed the two lines
                carrying

                  {"_variant_label":"2m x 2m","_price":"$480"}
                  {"_variant_label":"2m x 2m","_price":"$960"}

                — same variant, different property, so they could not merge.

                The cause is that `priceText` was scraped from the rendered
                `.pp-booking-card-price` element, which shows a RUNNING TOTAL for the
                quantity on the card. The second add captured the price of two units and
                stamped it on a line of one. So the property was not only splitting
                lines, it was WRONG — and booking-bar.js re-sent whatever it found when
                re-adding a line during a band change, so the wrong figure persisted and
                never self-corrected.

                Removed rather than repaired. Nothing displayed it: everything on screen
                comes from `item.final_line_price` or `cart.total_price`, and the only two
                references simply carried it forward. A line item should hold stable facts
                about the customer's CHOICE — `_variant_label` is one, a money snapshot
                the cart recalculates anyway is not.

                DO NOT REINSTATE. If a price is ever needed on the line, take it from the
                variant, never from rendered text — a scraped display string changes shape
                whenever the display does, and it fails silently.

                The matching read in booking-bar.js and the publish in booking-bar.liquid
                came out in the same pass, deliberately: leaving either one sending
                '_price': '' would still be a property mismatch and would still split
                every repeat line. */
            const properties = {
                '_variant_label': variantLabel,
            };

            // ── Only add if product has a cable kit code ───────
            if (code) {
                properties['Cable kit'] = `${code} x ${kitCount}`;
            }

            /* Show the drawer NOW. Everything below is two sequential round-trips, and
               openCartDrawer at the end of the chain adds a third before the panel was
               visible at all. The customer's tap is acknowledged immediately; the
               contents arrive when they arrive. */
            if (typeof window.showCartDrawer === 'function') window.showCartDrawer();

            addToCartRequest(variantId, currentQty, properties)
                .then(() => {
                    // ── Write booking data to cart attributes ──────
                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            attributes: {
                                'Location':        currentBooking.locationData?.name || '',
                                'Location suburb': currentBooking.locationData?.suburb || '',
                                'Charged nights':  String(nightsCharged),
                                'Pick up':         formatDateDMY(currentBooking.startDate),
                                'Pick up time':    pickupTime,
                                'Return':          formatDateDMY(currentBooking.endDate),
                                'Return time':     returnTime,
                                '_pick_up_iso':    currentBooking.startDate,
                                '_return_iso':     currentBooking.endDate,
                            }
                        })
                    });

                })
                .then(() => {
                    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();

                    /* Now the line exists, so the panel can be rendered from the cart.
                       After the drawer deliberately: the drawer is the confirmation the
                       customer is looking at, and the panel is what they come back to
                       when they scroll up. */
                    if (window.BookingRow) window.BookingRow.refreshPanels();
                })
                .catch(err => {
                    console.error('Cart add error:', err);

                    /* The drawer was opened optimistically the moment the button was
                       pressed. Nothing went in, so take it away rather than leaving a
                       booking panel sitting over a failed add. */
                    if (typeof window.closeCartDrawer === 'function') window.closeCartDrawer();

                    pdpAddError(err.shopifyDescription
                        || 'We could not add that just now. Try again, or give us a call.');
                });
        }

        /* ── Showing it ───────────────────────────────────────────────────────────
           Not here any more, and not with a class set optimistically. The panel is
           refreshed from the server once the line is actually in the cart — see the
           refreshPanels() call in the add chain above — and booking-row.js puts
           is-visible on this container only if rows came back.

           Setting it here showed an empty panel for the length of the round-trip, and
           left it showing if the add failed. */

        /* Hand the button over to step 2. The drawer is already opening — it is the
           confirmation, so nothing else needs to announce the add. */
        awaitingNewItem = true;

        // ── Update CTA ─────────────────────────────────────────
        updateCTAState();

    } catch (err) {
        console.error('addToBooking error:', err.message);
    }
}


function initBookingCardCTA() {
    /*  Remove and the stepper live in booking-row.js now, and they know nothing about
        this card. Without this the CTA kept saying "Add another" after the last line
        had been removed. */
    document.addEventListener('bookingrow:updated', function () {
        if (typeof updateCTAState === 'function') updateCTAState();
    });

    const btn       = document.querySelector('.pp-booking-card-btn');
    const gateCount = document.querySelectorAll('.pp-booking-card-gate').length;

    if (!btn) return;

    // ── Gate checkbox toggle ───────────────────────────────
    document.addEventListener('click', function (e) {
        const gate = e.target.closest('.pp-booking-card-gate');
        if (!gate) return;

        const checkbox = gate.querySelector('.pp-booking-card-checkbox');
        if (checkbox) {
            checkbox.classList.toggle('is-checked');
            if (checkbox.classList.contains('is-checked')) {
                checkbox.classList.remove('is-error');
            }
        }

        const checkedGates    = document.querySelectorAll('.pp-booking-card-checkbox.is-checked');
        const currentGateCount = document.querySelectorAll('.pp-booking-card-gate').length;
        const allGatesChecked = checkedGates.length === currentGateCount;
        const gateMsg         = document.querySelector('.pp-booking-card-gate-error-msg');

        if (allGatesChecked && gateMsg) {
            gateMsg.textContent = '';
            gateMsg.classList.remove('is-visible');
        }

        updateCTAState();
    });

    /*  Leave step 2 the moment an option is touched.

        Without this you get a card whose options the customer has already changed
        while the button still says "Add another" — so pressing it would throw their
        change away and reset everything. Changing an option IS starting a new item,
        so the button becomes "Add to booking" and nothing is cleared.

        Deliberately does not reset the other options: they changed one thing on
        purpose. */
    function leaveAwaitingOnEdit(e) {
        if (!awaitingNewItem) return;
        if (e.target.closest('.pp-booking-card-btn')) return;   // handled by the click below
        if (!e.target.closest('.pp-bcm-variant, .pp-bcm-variant-select, .pp-bcm-qty-min, .pp-bcm-qty-plus, .pp-bcm-qty-presets-btn, .pp-booking-card-mode-variant-options')) return;
        awaitingNewItem = false;
        updateCTAState();
    }
    document.addEventListener('click', leaveAwaitingOnEdit);
    document.addEventListener('change', leaveAwaitingOnEdit);

    // ── CTA click ──────────────────────────────────────────
    btn.addEventListener('click', function () {
        const collectEl = document.querySelector('.pp-booking-card-collect-line');

        // ── Not ready — show blocked message and return ────────
        if (btn.classList.contains('is-standby')) {
            if (collectEl) collectEl.textContent = window.ppSection?.card_cta_blocked || '';
            return;
        }

        /* Step 2. Prepare the card and hand the button back — do not add.
           Ahead of the gate check on purpose: there is nothing to validate, because
           nothing is being added. */
        if (awaitingNewItem) {
            startNewItem();
            return;
        }

        // ── Gate check (only runs when ready) ─────────────────
        const gateMsg         = document.querySelector('.pp-booking-card-gate-error-msg');
        const checkedGates    = document.querySelectorAll('.pp-booking-card-checkbox.is-checked');
        const allGatesChecked = checkedGates.length === gateCount;

        if (gateCount > 0 && !allGatesChecked) {
            const uncheckedGates = document.querySelectorAll('.pp-booking-card-checkbox:not(.is-checked)');
            if (gateMsg) {
                gateMsg.textContent = uncheckedGates.length === 1
                    ? (window.ppSection?.card_cta_gate      || 'Tick the checkbox above and you\'re good to go')
                    : (window.ppSection?.card_cta_gate_many || 'Tick all the boxes above and you\'re good to go');
                gateMsg.classList.add('is-visible');
            }
            document.querySelectorAll('.pp-booking-card-gate').forEach(gate => {
                const checkbox = gate.querySelector('.pp-booking-card-checkbox');
                if (checkbox && !checkbox.classList.contains('is-checked')) {
                    checkbox.classList.add('is-error');
                }
            });
            return;
        }

        if (gateMsg) {
            gateMsg.textContent = '';
            gateMsg.classList.remove('is-visible');
        }

        addToBooking();
    });

    // ── Update CTA state ───────────────────────────────────
    function updateCTAState() {
        const hasBooking = currentBooking.startDate && currentBooking.endDate && currentBooking.locationData;
        const collectEl  = document.querySelector('.pp-booking-card-collect-line');

        if (!hasBooking) {
            btn.classList.add('is-standby');
            btn.textContent = window.ppSection?.card_cta_no_dates || 'Check availability';
            if (collectEl) collectEl.textContent = '';
            return;
        }

        // ── Has valid booking ──────────────────────────────────
        btn.classList.remove('is-standby');

        /* Driven by awaitingNewItem, not by whether anything has been added.

           It used to key off bookedItems.length, so once one item was in the booking
           the button said "Add another" forever — including immediately after step 2
           had cleared the options, when the honest label is "Add to booking" again. */
        if (awaitingNewItem) {
            btn.textContent = window.ppSection?.card_cta_add_another || 'Add another';
            /* A different kind of action, so a different look. Outlined in
               pp-product.css — pressing it prepares the card, it does not add. */
            btn.classList.add('is-add-another');
        } else {
            btn.textContent = window.ppSection?.card_cta_add || 'Add to booking';
            btn.classList.remove('is-add-another');
        }
        if (collectEl) collectEl.textContent = window.ppSection?.card_collect_line || '';
    }

    /*  dev-build 289: "Add another" reverts once this product is no longer in the booking.
        The confirmation panel (.pp-booking-card-booked-info) is the record of that:
        booking-row.js takes its is-visible off after a Remove empties it. So when it
        stops being visible, the card is no longer awaiting a second item. */
    (function () {
        const panel = document.querySelector('.pp-booking-card-booked-info');
        if (!panel) return;
        new MutationObserver(function () {
            if (!panel.classList.contains('is-visible') && awaitingNewItem) {
                awaitingNewItem = false;
                updateCTAState();
            }
        }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    })();

    window.updateCTAState = updateCTAState;
}


/* ── Mobile title reorder ────────────────────────────────────
    Moves .pp-booking-title-review to top of
    .pp-body-container on mobile                            */
function reorderMobileTitle() {
    const titleEl     = document.querySelector('.pp-booking-title-review');
    const containerEl = document.querySelector('.pp-body-container');

    if (!titleEl || !containerEl) return;

    if (window.innerWidth <= 880) {
        containerEl.prepend(titleEl);
    } else {
        const bookingEl = document.querySelector('.pp-booking');
        if (bookingEl) bookingEl.prepend(titleEl);
    }
}

// ── Listen & init ──────────────────────────────────────────────────────────
document.addEventListener('bookingbar:changed', onBookingBarChanged);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initBranchPanel();
        initPriceBreakdown();
        initMatrixMode();
        initPerUnitMode();
        initPerUnitVariants();
        updateRowPrices();
        updateCapacitySecondOptionPrices();
        initBookingCardCTA();
        reorderMobileTitle();
        updateBookingGates();
        updateCableKit();
        updateSetupTime();
        window.addEventListener('resize', reorderMobileTitle);
    });
} else {
    initBranchPanel();
    initPriceBreakdown();
    initMatrixMode();
    initPerUnitMode();
    initPerUnitVariants();
    updateRowPrices();
    updateCapacitySecondOptionPrices();
    initBookingCardCTA();
    reorderMobileTitle();
    updateBookingGates();
    updateCableKit();
    updateSetupTime();
    window.addEventListener('resize', reorderMobileTitle);
}

/*  dev-build 253 — hide a review's title when it only repeats the start of the review
    ("Perfectly loud and balanced" / "Perfectly loud and balanced"). Yotpo draws and
    re-draws the list itself (paging, search, filters), so this watches the widget and
    re-checks whenever it changes. Only adds a class; never removes Yotpo's markup. */
(function () {
  var norm = function (s) { return (s || '').toLowerCase().replace(/read more|read less/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); };
  function mark(root) {
    root.querySelectorAll('.yotpo-review-title:not(.pp-review-title--checked)').forEach(function (t) {
      t.classList.add('pp-review-title--checked');
      var item = t.closest('.yotpo-reviews-item, .yotpo-review');
      var body = item && item.querySelector('.yotpo-review-content');
      var a = norm(t.textContent), c = norm(body && body.textContent);
      if (a && c && c.indexOf(a) === 0) t.classList.add('pp-review-title--dup');
    });
  }
  function watch() {
    var w = document.querySelector('[data-pp-reviews-widget]');
    if (!w || w.dataset.ppTitleWatch) return;
    w.dataset.ppTitleWatch = '1';
    mark(w);
    new MutationObserver(function () { mark(w); }).observe(w, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();


/* ─────────────────────────────────────────────────────────────
   WHAT'S INCLUDED — dev-build 260, task 194
   Reads the [data-pp-modal-panel="wi"] panel rendered by pp-body.liquid from
   custom.whats_included, and works out each item's quantity and visibility
   from the booking card choices. Rules match djw-whats-included-migration.py:
     No             Q
     Yes            Q x hire quantity
     1 per every N  Q x ceil(hire quantity / N)
     From option    (Q x ceil(measure / N) + plus) x hire quantity (dev-build 275), from the picked value of the
                    named option. measure: number (first number, prices like
                    "(+$30)" ignored) | area | longest side | other three sides
                    | shortest side, from a size like "6m x 4m". Hidden with no
                    number, a result of 0, or a measure below "only from".
   Show when picked: shown when any picked value STARTS WITH the text, not
   case-sensitive; "A | B" means either. Empty = always.
   Re-run after any click or change, so it follows whatever pp-product.js did. */
(function () {
  function num(v) {
    var s = String(v == null ? '' : v).replace(/\(\s*\+?\s*\$[^)]*\)/g, '');
    var m = s.match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  function dims(v) {
    var m = String(v == null ? '' : v).match(/(\d+(?:\.\d+)?)\s*m?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }
  function measure(kind, v) {
    kind = (kind || 'number').toLowerCase();
    if (kind === 'number') return num(v);
    var d = dims(v); if (!d) return null;
    var L = Math.max(d[0], d[1]), S = Math.min(d[0], d[1]);
    if (kind === 'area') return d[0] * d[1];
    if (kind === 'longest side') return L;
    if (kind === 'other three sides') return L + 2 * S;
    if (kind === 'shortest side') return S;
    return null;
  }
  function picks(names) {
    var out = {};
    var set = function (idx, val) { var n = names[idx]; if (n != null && val != null) out[String(n).toLowerCase()] = String(val); };
    document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(function (b) { set(parseInt(b.dataset.optionIndex, 10), b.dataset.value); });
    document.querySelectorAll('.pp-bcm-variant-select').forEach(function (s) {
      var o = s.options[s.selectedIndex]; if (o) set(parseInt(s.dataset.optionIndex, 10), o.dataset.value || o.value);
    });
    var mx = document.querySelector('.pp-booking-card-mode-variant-options');
    if (mx) { var o = mx.options[mx.selectedIndex]; if (o) set(1, o.dataset.option2); }
    // An option with no control on the card (one value only) reads from the first variant.
    var v0 = window.ppSection && window.ppSection.variants && window.ppSection.variants[0];
    names.forEach(function (n, i) { var k = String(n).toLowerCase(); if (!(k in out) && v0 && v0['option' + (i + 1)] != null) out[k] = String(v0['option' + (i + 1)]); });
    return out;
  }
  function hireQty() {
    var el = document.querySelector('.pp-bcm-qty-value');
    var q = el ? parseInt(el.textContent, 10) : 1;
    return q > 0 ? q : 1;
  }
  function render() {
    var panel = document.querySelector('[data-pp-modal-panel="wi"]');
    if (!panel) return;
    var names = [];
    try { names = JSON.parse(panel.dataset.wiOptions || '[]'); } catch (e) {}
    var p = picks(names);
    var vals = Object.keys(p).map(function (k) { return p[k].toLowerCase(); });
    var hq = hireQty();
    panel.querySelectorAll('[data-wi-item]').forEach(function (li) {
      var d = li.dataset;
      var Q = parseFloat(d.wiQ) || 1, N = parseInt(d.wiN, 10) || 1, plus = parseFloat(d.wiPlus) || 0;
      var q = Q, show = true;
      if (d.wiWhen) {
        var alts = d.wiWhen.toLowerCase().split('|').map(function (s) { return s.trim(); }).filter(Boolean);
        show = alts.some(function (a) { return vals.some(function (v) { return v.indexOf(a) === 0; }); });
      }
      if (d.wiMode === 'Yes') q = Q * hq;
      else if (d.wiMode === '1 per every N') q = Q * Math.ceil(hq / N);
      else if (d.wiMode === 'From option') {
        var raw = p[String(d.wiOpt || '').toLowerCase()];
        var m = raw == null ? null : measure(d.wiMeasure, raw);
        var from = parseFloat(d.wiFrom);
        if (m == null || (!isNaN(from) && m < from)) show = false;
        // dev-build 275: x hire quantity, so 2 packs hired = twice the contents
        else q = (Q * Math.ceil(m / N) + plus) * hq;
      }
      q = Math.round(q * 100) / 100;
      if (!(q > 0)) show = false;
      li.hidden = !show;
      var qe = li.querySelector('[data-wi-qty]');
      if (qe) qe.textContent = q + ' \u00d7';
    });
    var shown = [];
    panel.querySelectorAll('[data-wi-section]').forEach(function (s) {
      var n = s.querySelectorAll('[data-wi-item]:not([hidden])').length;
      s.hidden = n === 0;
      if (n) shown.push(s);
      var c = s.querySelector('[data-wi-count]');
      if (c) c.textContent = n === 1 ? '1 item' : n + ' items';
    });
    // dev-build 261: with only one section showing, its heading repeats the panel title, so hide it.
    shown.forEach(function (s) {
      var h = s.querySelector('[data-wi-head]');
      if (h) h.hidden = shown.length === 1;
    });
    var empty = panel.querySelector('[data-wi-empty]');
    if (empty) empty.hidden = !!panel.querySelector('[data-wi-item]:not([hidden])');
  }
  function soon() { setTimeout(render, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  document.addEventListener('click', soon);
  document.addEventListener('change', soon);
  window.ppWhatsIncludedRefresh = render;
})();


/* ─────────────────────────────────────────────────────────────
   FAQ ACCORDION — dev-build 270 (replaces 269's). One answer open per FAQ card,
   and answers slide open and closed instead of snapping. The click on a question
   is taken over so the closing one can finish its slide before it shuts. With
   "reduce motion" switched on in the device settings, it snaps as before.
───────────────────────────────────────────────────────────────*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function body(d) { return d.querySelector('.pp-faq-a'); }
  function stop(a) { if (a && a._ppAnim) { a._ppAnim.cancel(); a._ppAnim = null; } }
  function open(d) {
    var a = body(d); stop(a);
    d.open = true;
    if (reduce || !a || !a.animate) return;
    var h = a.scrollHeight;
    a._ppAnim = a.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)' });
    a._ppAnim.onfinish = function () { a._ppAnim = null; };
  }
  function close(d) {
    var a = body(d); stop(a);
    if (reduce || !a || !a.animate) { d.open = false; return; }
    var h = a.offsetHeight;
    a._ppAnim = a.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'cubic-bezier(.4,0,.6,1)' });
    a._ppAnim.onfinish = function () { a._ppAnim = null; d.open = false; };
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.pp-faq-q');
    if (!q) return;
    var d = q.parentElement;
    if (!d || d.tagName !== 'DETAILS') return;
    e.preventDefault();
    var card = d.closest('.pp-faq-card');
    // Open and not already closing: close it. Otherwise open it and close the rest.
    if (d.open && !d._ppClosing) { d._ppClosing = true; close(d); setTimeout(function () { d._ppClosing = false; }, 220); return; }
    d._ppClosing = false;
    if (card) card.querySelectorAll('.pp-faq-row[open]').forEach(function (o) { if (o !== d) close(o); });
    open(d);
  });
})();


/* ─────────────────────────────────────────────────────────────
   UNAVAILABLE COMBINATIONS — dev-build 271, variant source fixed in 272
   A choice that has no variant with the other choices currently picked (e.g. on
   Portable Complete DJ System) is greyed out, can't be picked, and says "Not
   available with your selection". Worked out from window.ppSection.variants
   against the picks on the card; options with no control on the card (Hire Period)
   are ignored. The picked choice itself is never greyed, so the card can't lock up.
   Re-run after every click or change, after the card's own handlers.
───────────────────────────────────────────────────────────────*/
(function () {
  var MSG = 'Not available with your selection';
  // dev-build 272: window.ppSection.variants is only filled for some card modes (it was
  // empty on Portable Complete DJ System). So, when it is empty, the product's own
  // variant list is fetched once from Shopify (/products/<handle>.js) and kept.
  var fetched = null, fetching = false;
  function variants() {
    var v = window.ppSection && window.ppSection.variants;
    if (v && v.length) return v;
    if (fetched) return fetched;
    if (!fetching) {
      fetching = true;
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.variants) { fetched = d.variants; run(); } })
        .catch(function () {});
    }
    return [];
  }
  function picks() {
    var p = {};
    document.querySelectorAll('.pp-bcm-variant.is-selected').forEach(function (b) { p[b.dataset.optionIndex] = b.dataset.value; });
    document.querySelectorAll('.pp-bcm-variant-select').forEach(function (s) {
      var o = s.options[s.selectedIndex]; if (o) p[s.dataset.optionIndex] = o.dataset.value || o.value;
    });
    return p;
  }
  function exists(idx, value, p) {
    return variants().some(function (v) {
      if (String(v['option' + (+idx + 1)]) !== String(value)) return false;
      for (var k in p) { if (k !== String(idx) && String(v['option' + (+k + 1)]) !== String(p[k])) return false; }
      return true;
    });
  }
  function run() {
    if (!variants().length) return;
    var p = picks();
    document.querySelectorAll('.pp-bcm-variant[data-option-index]').forEach(function (b) {
      var na = !b.classList.contains('is-selected') && !exists(b.dataset.optionIndex, b.dataset.value, p);
      b.classList.toggle('is-unavailable', na);
      b.setAttribute('aria-disabled', na ? 'true' : 'false');
      var m = b.querySelector('.pp-bcm-variant-na');
      if (na && !m) { m = document.createElement('span'); m.className = 'pp-bcm-variant-na'; m.textContent = MSG; b.appendChild(m); }
      if (!na && m) m.remove();
    });
    document.querySelectorAll('.pp-bcm-variant-select').forEach(function (s) {
      Array.prototype.forEach.call(s.options, function (o, i) {
        if (o.dataset.ppLabel == null) o.dataset.ppLabel = o.textContent;
        var na = i !== s.selectedIndex && !exists(s.dataset.optionIndex, o.dataset.value || o.value, p);
        o.disabled = na;
        o.textContent = na ? o.dataset.ppLabel.trim() + ' \u2014 ' + MSG.toLowerCase() : o.dataset.ppLabel;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pp-bcm-variant.is-unavailable');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  function soon() { setTimeout(run, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('click', soon);
  document.addEventListener('change', soon);
  window.ppUnavailableRefresh = run;
})();


/* ─────────────────────────────────────────────────────────────
   PACKAGE CONTENTS — dev-build 273
   Items inside a linked package (ul[data-wi-sub], rendered by pp-body.liquid) use
   the same rules as top-level items, but against that package's default choices
   (data-wi-picks) and with "hire quantity" = the quantity shown on the package line.
   Runs after the WHAT'S INCLUDED pass, so the package line's number is already set.
───────────────────────────────────────────────────────────────*/
(function () {
  function num(v) { var m = String(v == null ? '' : v).replace(/\(\s*\+?\s*\$[^)]*\)/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : null; }
  function dims(v) { var m = String(v == null ? '' : v).match(/(\d+(?:\.\d+)?)\s*m?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
  function measure(kind, v) {
    kind = (kind || 'number').toLowerCase();
    if (kind === 'number') return num(v);
    var d = dims(v); if (!d) return null;
    var L = Math.max(d[0], d[1]), S = Math.min(d[0], d[1]);
    return kind === 'area' ? d[0] * d[1] : kind === 'longest side' ? L : kind === 'other three sides' ? L + 2 * S : kind === 'shortest side' ? S : null;
  }
  function run() {
    document.querySelectorAll('[data-wi-sub]').forEach(function (ul) {
      var parent = ul.closest('[data-wi-item]');
      var pq = 1;
      if (parent) { var t = parent.querySelector(':scope > .pp-modal-included-info [data-wi-qty]'); pq = t ? (parseFloat(t.textContent) || 1) : 1; }
      var picks = {};
      try { picks = JSON.parse(ul.dataset.wiPicks || '{}'); } catch (e) {}
      var vals = Object.keys(picks).map(function (k) { return String(picks[k]).toLowerCase(); });
      var shown = 0;
      ul.querySelectorAll('[data-wi-sub-item]').forEach(function (li) {
        var d = li.dataset;
        var Q = parseFloat(d.wiQ) || 1, N = parseInt(d.wiN, 10) || 1, plus = parseFloat(d.wiPlus) || 0;
        var q = Q, show = true;
        if (d.wiWhen) {
          var alts = d.wiWhen.toLowerCase().split('|').map(function (s) { return s.trim(); }).filter(Boolean);
          show = alts.some(function (a) { return vals.some(function (v) { return v.indexOf(a) === 0; }); });
        }
        if (d.wiMode === 'Yes') q = Q * pq;
        else if (d.wiMode === '1 per every N') q = Q * Math.ceil(pq / N);
        else if (d.wiMode === 'From option') {
          var raw = picks[String(d.wiOpt || '').toLowerCase()];
          var m = raw == null ? null : measure(d.wiMeasure, raw);
          var from = parseFloat(d.wiFrom);
          if (m == null || (!isNaN(from) && m < from)) show = false;
          else q = (Q * Math.ceil(m / N) + plus) * pq;
        } else q = Q * pq;
        q = Math.round(q * 100) / 100;
        if (!(q > 0)) show = false;
        li.hidden = !show;
        if (show) shown++;
        var qe = li.querySelector('[data-wi-qty]');
        if (qe) qe.textContent = q + ' \u00d7';
      });
      ul.hidden = shown === 0;
    });
  }
  function soon() { setTimeout(function () { setTimeout(run, 0); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  document.addEventListener('click', soon);
  document.addEventListener('change', soon);
})();


/* ─────────────────────────────────────────────────────────────
   TECH SPECS — dev-build 276 (Tech Specs Panel.dc.html 2c/2a, Ben 03-10-2026)
   A pack's Tech specs panel ([data-pp-modal-panel="ts"] with [data-ts-list]) lists
   the What's included items that have specs. Each line copies its number, and
   whether it shows, from the What's included line with the same key
   (data-wi-key), so it follows the booking card choices and hire quantity. A
   line inside a linked pack also needs that pack's line to be showing. Tapping a
   line shows that item's specs; "All items" goes back. Opening the tile always
   starts on the list. Runs after WHAT'S INCLUDED and PACKAGE CONTENTS.
───────────────────────────────────────────────────────────────*/
(function () {
  function shown(el) {
    for (var n = el; n && !n.matches('[data-pp-modal-panel]'); n = n.parentElement) { if (n.hidden) return false; }
    return true;
  }
  function refresh() {
    var panel = document.querySelector('[data-pp-modal-panel="ts"]');
    var list = panel && panel.querySelector('[data-ts-list]');
    if (!list) return;
    var wi = document.querySelector('[data-pp-modal-panel="wi"]');
    var any = false;
    list.querySelectorAll('[data-ts-key]').forEach(function (row) {
      var src = wi && wi.querySelector('[data-wi-key="' + row.dataset.tsKey + '"]');
      var on = !!src && shown(src);
      row.hidden = !on;
      if (on) {
        any = true;
        var q = src.querySelector('[data-wi-qty]'), t = row.querySelector('[data-ts-qty]');
        if (q && t) t.textContent = q.textContent;
      }
    });
    // dev-build 278: a pack group (or the pack's own card) hides when none of its items show.
    list.querySelectorAll('[data-ts-group]').forEach(function (g) { g.hidden = !g.querySelector('[data-ts-key]:not([hidden])'); });
    var empty = list.querySelector('[data-ts-empty]');
    if (empty) empty.hidden = any;
  }
  function showList(panel) {
    var list = panel.querySelector('[data-ts-list]'); if (!list) return;
    panel.querySelectorAll('[data-ts-detail]').forEach(function (d) { d.hidden = true; });
    list.hidden = false;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var panel = document.querySelector('[data-pp-modal-panel="ts"]'); if (!panel) return;
    var open = t.closest('[data-ts-open]');
    if (open && panel.contains(open)) {
      var d = panel.querySelector('[data-ts-detail="' + open.dataset.tsOpen + '"]');
      if (!d) return;
      panel.querySelector('[data-ts-list]').hidden = true;
      d.hidden = false;
      var body = panel.closest('[data-pp-modal-body]'); if (body) body.scrollTop = 0;
      return;
    }
    if (t.closest('[data-ts-back]') && panel.contains(t)) { showList(panel); return; }
    if (t.closest('[data-pp-modal-open="ts"]')) showList(panel);
  });
  function soon() { setTimeout(function () { setTimeout(function () { setTimeout(refresh, 0); }, 0); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  document.addEventListener('click', soon);
  document.addEventListener('change', soon);
})();


/* ─────────────────────────────────────────────────────────────
   PAGE LAYOUT — dev-build 282 (Product Page.dc.html)
   1. Key features: "+N more" / "Show all N" shows the rest; tap again to fold.
   2. Photo mosaic: any tile or "See all N photos" opens the Photo tour lightbox
      (the same element the See all thumbnail opens).
   3. BAR TEXT: the What's included bar on an item shows how many lines are showing
      in its panel for the current choices. Counts top-level lines only (an item
      inside a linked pack is part of its pack's line). Runs after WHAT'S INCLUDED.
───────────────────────────────────────────────────────────────*/
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pp-features-toggle], [data-pp-mosaic-open]') : null;
    if (!t) return;
    if (t.hasAttribute('data-pp-features-toggle')) {
      var box = t.closest('[data-pp-features]'); if (!box) return;
      var on = box.classList.toggle('is-all');
      t.textContent = on ? t.dataset.less : t.dataset.more;
      return;
    }
    var lb = document.querySelector('.pp-media__lightbox');
    if (lb) { e.preventDefault(); lb.classList.add('is-active'); }
  });
  function shown(el) {
    for (var n = el; n && !n.matches('[data-pp-modal-panel]'); n = n.parentElement) { if (n.hidden) return false; }
    return true;
  }
  function count() {
    var bars = document.querySelectorAll('[data-wi-bar-count]'); if (!bars.length) return;
    var wi = document.querySelector('[data-pp-modal-panel="wi"]'); if (!wi) return;
    var n = 0;
    wi.querySelectorAll('[data-wi-item]').forEach(function (li) { if (shown(li)) n++; });
    /* dev-build 286: two copies now, the long one and the phones' short one. */
    bars.forEach(function (bar) { bar.textContent = (bar.dataset.tpl || '[n] items').replace('[n]', n); });
  }
  function soon() { setTimeout(function () { setTimeout(function () { setTimeout(count, 0); }, 0); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  document.addEventListener('click', soon);
  document.addEventListener('change', soon);
})();


/* ─────────────────────────────────────────────────────────────
   BOOKING CARD — dev-build 284 (Booking Card Final.dc.html)
   The card's own code keeps writing the statues, the availability band, the price,
   the nights and the cancel date. This block only READS those and keeps the new
   pieces in step: the availability pill beside the name, the bond block, the dates
   point and the timeline. It writes nothing the card's own code reads, so there is
   still one owner of every state. Runs from a MutationObserver on the card, and
   writes only when a value has changed, so it cannot loop.
   BOND for your booking = max( base, highest single raise, sum of stacks × qty ),
   the cart's rule (pb-cart.liquid). The cart's part comes from Liquid on the bond
   block; this product is added at the card's current quantity (currentQty above).
───────────────────────────────────────────────────────────────*/
(function () {
  function fmt(c) {
    c = Math.round(c);
    return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }
  function setCls(el, c) { if (el && el.className !== c) el.className = c; }

  function sync() {
    var card = document.querySelector('.pp-bc'); if (!card) return;
    var dateEl = card.querySelector('.pp-booking-card-statue-date');
    var locEl = card.querySelector('.pp-booking-card-statue-location');
    var band = card.querySelector('.pp-booking-card-available');
    var has = !!(dateEl && dateEl.classList.contains('active'));
    var bandOn = !!(band && band.style.display !== 'none');
    var out = bandOn && band.classList.contains('is-bookedout');
    var limited = bandOn && (band.classList.contains('is-substitute') || band.classList.contains('is-override'));

    var pill = card.querySelector('[data-pp-bc-pill]'), pillText = card.querySelector('[data-pp-bc-pill-text]');
    var state = !has ? 'none' : out ? 'out' : limited ? 'limited' : bandOn ? 'ok' : 'none';
    setCls(pill, 'pp-bc-pill is-' + state);
    setText(pillText, state === 'none' ? (has ? 'Checking…' : 'Set dates to check')
      : state === 'out' ? 'Booked out' : state === 'limited' ? ((band && band.dataset.pill) || 'Limited')
      : (card.dataset.availLong === 'true' ? 'Available for your dates' : 'Available'));
    if (band) band.classList.toggle('pp-bc-band-quiet', state === 'ok');

    var bond = card.querySelector('[data-bc-bond]');
    if (bond) {
      setHidden(bond, !has || out);
      var q = (typeof currentQty === 'number' && currentQty > 0) ? currentQty : 1;
      var amt = +bond.dataset.amount || 0, mode = bond.dataset.mode;
      var raise = +bond.dataset.raise || 0, stack = +bond.dataset.stack || 0;
      if (mode === 'Raise' || mode === 'Raise & Stack') raise = Math.max(raise, amt);
      if (mode === 'Raise & Stack') stack += amt * q;
      var total = Math.max(+bond.dataset.base || 0, raise, stack);
      bond.querySelectorAll('[data-bc-bond-total]').forEach(function (el) { setText(el, fmt(total)); });
    }

    var dates = dateEl ? dateEl.textContent.trim() : '';
    setHidden(card.querySelector('[data-bc-dates-point]'), !has);
    setText(card.querySelector('[data-bc-dp-branch]'), locEl ? locEl.textContent.trim() : '');
    setText(card.querySelector('[data-bc-dp-dates]'), dates);
    var tl = card.querySelector('[data-bc-timeline]');
    if (tl) {
      setHidden(tl, !has);
      var parts = dates.split(/\s+[-–]\s+/);
      setText(card.querySelector('[data-bc-tl-pick]'), parts[0] || '');
      setText(card.querySelector('[data-bc-tl-return]'), parts[1] || '');
      var nn = (card.querySelector('.pp-booking-card-price-for-nights') || {}).textContent || '';
      var m = nn.match(/(\d+)\s*night/);
      if (m) setText(card.querySelector('[data-bc-tl-nights]'), m[1] + (m[1] === '1' ? ' night' : ' nights'));
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bc-bond-toggle]') : null;
    if (!t) return;
    var est = t.closest('[data-bc-bond]').querySelector('[data-bc-bond-est]');
    if (est) est.hidden = !est.hidden;
  });

  function start() {
    var card = document.querySelector('.pp-bc'); if (!card) return;
    sync();
    new MutationObserver(sync).observe(card, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('click', function () { setTimeout(sync, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();


/* ─────────────────────────────────────────────────────────────
   BOND POP-UP — dev-build 285. "More info" on the booking card opens the rental
   bond page's content (rendered by pp-booking.liquid) in a pop-up matching the
   cart's. No pop-up on the page (no bond page chosen) → the link works as a link.
───────────────────────────────────────────────────────────────*/
(function () {
  var last = null;
  var lockY = 0;
  function modal() { return document.querySelector('[data-bc-bond-modal]'); }
  /*  Same extraction as the cart's pop-up (pb-cart.liquid, extract()), so the two show
      the same part of the page. Fetched once, then kept. */
  function fill(m) {
    var body = m.querySelector('[data-bc-bond-body]');
    if (!body || body.textContent.trim() || body.dataset.loading) return;
    var href = body.dataset.src; if (!href) return;
    body.dataset.loading = '1';
    body.innerHTML = '<div class="pp-bc-modal__status"><span class="pp-bc-modal__spinner" aria-hidden="true"></span><span>Fetching rental bond\u2026</span></div>';
    fetch(href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* 610: the bond page is built from the new info sections now. Take those (not the old
           rich-text body), and bring their stylesheets along — they were being stripped, so the
           content showed unstyled here while the cart looked right. */
        var main = doc.querySelector('#main-content') || doc.querySelector('main');
        var el = (main && main.querySelector('[class*="dji"]')) ? main : (doc.querySelector('.post-content.rte') || main);
        if (!el) throw new Error('no content');
        doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
          var h = l.getAttribute('href') || ''; if (!/djw-info|section-|djw-/.test(h)) return;
          var key = h.split('?')[0];
          if ([].some.call(document.querySelectorAll('link[rel="stylesheet"]'), function (x) { return (x.getAttribute('href') || '').split('?')[0] === key; })) return;
          var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = h; document.head.appendChild(n);
        });
        el.querySelectorAll('script, link, iframe, form, noscript, .shopify-section-group-header-group, .shopify-section-group-footer-group, [class*="booking-bar"], .djw-info-book, [class*="dji-book"], .breadcrumbs').forEach(function (n) { n.remove(); });
        /* 611: the info sections only take their pop-up layout (no intro, tighter bands, the
           three steps in a row when there's room) inside .pb-modal-body — the cart's pop-up
           class. The product page's pop-up wears it too now, so both look the same. */
        body.classList.add('pb-modal-body'); body.style.containerType = 'inline-size';
        body.innerHTML = el.innerHTML;
        body.scrollTop = 0;
      })
      .catch(function () {
        delete body.dataset.loading;
        body.innerHTML = '<div class="pp-bc-modal__status"><span>We couldn\u2019t load this here. <a href="' + href + '" target="_blank" rel="noopener">Open it in a new tab</a> instead.</span></div>';
      });
  }
  function close() {
    var m = modal(); if (!m || m.hidden) return;
    m.hidden = true; document.documentElement.classList.remove('pp-bc-modal-open');
    document.body.style.top = ''; window.scrollTo(0, lockY);
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var open = t.closest('[data-bc-bond-more]');
    if (open) {
      var m = modal(); if (!m) return;
      e.preventDefault(); last = open;
      /*  295: lifted to <body> before it shows. Inside the card on phones it sat under
          a parent that clips and offsets fixed elements, so its close button and its
          scrolling were out of reach. Safe to move: it hides itself with [hidden], not
          through its parent (THEME-CODE-RULES, 04-10-2026). Scroll is locked by pinning
          the page, because iOS ignores overflow: hidden on <html>. */
      if (m.parentNode !== document.body) document.body.appendChild(m);
      lockY = window.scrollY;
      document.body.style.top = (-lockY) + 'px';
      m.hidden = false; document.documentElement.classList.add('pp-bc-modal-open');
      fill(m);
      var c = m.querySelector('.pp-bc-modal__close'); if (c) c.focus();
      return;
    }
    if (t.closest('[data-bc-bond-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();


/* ─────────────────────────────────────────────────────────────
   DRAWER — dev-build 286 (Product Page Mobile.dc.html). Up to 880px the booking
   card is a sheet; the bar at the bottom opens it. The bar's price, nights and
   availability are copied from the card (price from .pp-booking-card-price, nights
   from .pp-booking-card-price-for-nights, availability from the card's pill), so the
   card stays the one owner. Also: the phone photo grid opens and closes here.
───────────────────────────────────────────────────────────────*/
(function () {
  var MQ = window.matchMedia('(max-width: 880px)');
  function q(s) { return document.querySelector(s); }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  var SHEET = null, SLOT = null;
  function open() {
    if (!MQ.matches) return;
    /* 288: the card lives in the page on phones; tapping the bar lifts it into a sheet. */
    if (SHEET && SHEET.parentNode !== document.body) { document.body.appendChild(SHEET); SHEET.classList.add('pp-sheet'); SHEET.classList.remove('pp-inline'); void SHEET.offsetHeight; }
    document.documentElement.classList.add('pp-msheet-open');
    var s = q('[data-pp-mdrawer-close].pp-mdrawer-scrim'); if (s) s.hidden = false;
    var b = q('[data-pp-mdrawer-open]'); if (b) b.setAttribute('aria-expanded', 'true');
  }
  function close() {
    var wasOpen = document.documentElement.classList.contains('pp-msheet-open');
    document.documentElement.classList.remove('pp-msheet-open');
    /* 288: back into the page once it has slid down (0.3s). */
    if (wasOpen && SHEET && SLOT && MQ.matches) setTimeout(function () {
      if (document.documentElement.classList.contains('pp-msheet-open')) return;
      SLOT.appendChild(SHEET); SHEET.classList.remove('pp-sheet'); SHEET.classList.add('pp-inline');
    }, 320);
    var s = q('.pp-mdrawer-scrim'); if (s) s.hidden = true;
    var b = q('[data-pp-mdrawer-open]'); if (b) b.setAttribute('aria-expanded', 'false');
  }
  function sync() {
    var price = q('.pp-bc .pp-booking-card-price');
    if (price) {
      var from = price.querySelector('.pp-booking-card-price-from');
      var txt = price.textContent.replace(from ? from.textContent : '', '').trim();
      var fromOn = from && from.style.display !== 'none' && from.textContent.trim();
      setText(q('[data-pp-md-price]'), (fromOn ? from.textContent.trim() + ' ' : '') + txt);
    }
    /* 626: copied as markup, not text, so the "?" arrives as the round button, not a
       literal "?". Written only when different, so the card's observer can't loop. */
    var nSrc = q('.pp-bc .pp-booking-card-price-for-nights'), nDst = q('[data-pp-md-nights]');
    if (nDst) { var nH = nSrc ? nSrc.innerHTML.trim() : ''; if (nDst.innerHTML !== nH) nDst.innerHTML = nH; }
    var pill = q('.pp-bc [data-pp-bc-pill]'), av = q('[data-pp-md-avail]');
    if (pill && av) {
      var cls = 'pp-mdrawer__avail ' + (pill.className.match(/is-\w+/) || ['is-none'])[0];
      if (av.className !== cls) av.className = cls;
      setText(q('[data-pp-md-avail-text]'), (q('.pp-bc [data-pp-bc-pill-text]') || {}).textContent || '');
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    /*  dev-build 290 (Ben 04-10-2026): the bar no longer opens a drawer. It takes you
        down to the booking card, which sits in the page on phones (288's slot). The
        header is sticky, so the scroll stops just below it. open()/close() stay for the
        Esc key and window resize, but nothing opens a sheet now. */
    if (t.closest('[data-pp-mdrawer-open]')) {
      var slotEl = q('[data-pp-mslot]'); if (!slotEl) return;
      var head = document.querySelector('.header-section');
      var off = (head ? head.getBoundingClientRect().bottom : 0) + 12;
      window.scrollTo({ top: slotEl.getBoundingClientRect().top + window.pageYOffset - Math.max(off, 12), behavior: 'smooth' });
      return;
    }
    if (t.closest('[data-pp-mdrawer-close]')) { close(); return; }
    if (t.closest('[data-pp-mgrid-open]')) { var g = q('[data-pp-mgrid]'); if (g) { g.hidden = false; document.documentElement.classList.add('pp-mgrid-open'); } return; }
    if (t.closest('[data-pp-mgrid-close]')) { var g2 = q('[data-pp-mgrid]'); if (g2) { g2.hidden = true; document.documentElement.classList.remove('pp-mgrid-open'); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); var g = q('[data-pp-mgrid]'); if (g && !g.hidden) { g.hidden = true; document.documentElement.classList.remove('pp-mgrid-open'); } } });
  (MQ.addEventListener ? MQ.addEventListener('change', function () { if (!MQ.matches) close(); }) : MQ.addListener(function () { if (!MQ.matches) close(); }));
  function start() {
    /*  287: out of the product section and onto <body>, so no later section (the
        footer) can paint over the bar. Queried by data attributes, so moving is safe. */
    ['[data-pp-mdrawer]', '.pp-mdrawer-scrim'].forEach(function (s) { var el = q(s); if (el && el.parentNode !== document.body) document.body.appendChild(el); });
    /*  287: chat. Front's launcher is an iframe fixed 20px from the bottom, right where
        "View options" is. While the bar shows (and the sheet is closed) the launcher is
        lifted above it by CSS on html.pp-md-on. Front sets its own size inline when the
        chat window opens; only its distance from the bottom is overridden. */
    function mark() { document.documentElement.classList.toggle('pp-md-on', MQ.matches); }
    /*  384 (Ben 12-10-2026): when the chat window is OPEN on a phone it is full height,
        so the lift above the bar pushed its top off screen, and the page behind still
        scrolled. Front gives the open window its own size; anything taller than the
        launcher is treated as open → html.pp-chat-open, which drops the lift, locks
        the page (on <html> only — see THEME-CODE-RULES) and hides the bar under it. */
    (function () {
      var root = document.documentElement, seen = null;
      function check() {
        var f = document.getElementById('front-chat-iframe');
        if (f !== seen) { seen = f; if (f) new MutationObserver(check).observe(f, { attributes: true, attributeFilter: ['style', 'class'] }); }
        /* 388: Front sets no inline size (readout: inline is position/border/z-index
           only), so 386's inline check could never see "open". Rendered size is safe
           again now that nothing of ours sizes the iframe. */
        var open = !!(f && f.offsetHeight > 160 && f.offsetWidth > 160 && getComputedStyle(f).visibility !== 'hidden');
        root.classList.toggle('pp-chat-open', open);
      }
      new MutationObserver(function () { if (!seen || !document.body.contains(seen)) check(); }).observe(document.body, { childList: true });
      window.addEventListener('resize', check);
      check();
    })();
    mark(); (MQ.addEventListener ? MQ.addEventListener('change', mark) : MQ.addListener(mark));
    /*  287c: the bar's real height, as --pp-md-h on <html>, so the chat button's spot
        follows it if the price or availability ever wraps to two lines. */
    var mdBar = q('[data-pp-mdrawer]');
    function measure() { if (mdBar) document.documentElement.style.setProperty('--pp-md-h', mdBar.offsetHeight + 'px'); }
    measure();
    if (mdBar && window.ResizeObserver) new ResizeObserver(measure).observe(mdBar);
    window.addEventListener('resize', measure);
    /*  288 (replaces 287f): on phones the card sits in the page, in the slot at the end
        of the content (pp-body.liquid), and is lifted into a sheet only while the drawer
        is open. Above 880px it goes back to its column. A marker comment keeps the
        column's place. Every script finds the card by class, so where it is does not
        matter to them. */
    /*  dev-build 294: REMOVED 289's move of .pp-modal-container, .pp-review-sidebar and
        .pp-review-sidebar-overlay to <body>. Their hidden state depends on where they
        sit, so on <body> they became invisible full-screen layers that swallowed every
        click on desktop (booking card buttons, gallery arrows). The move only existed to
        lift them above the phone drawer, which 290 removed. Do not reinstate. */
    /*  289: the cart drawer and the booking drawer both rise from the bottom. Opening the
        cart closes the booking drawer, so only one is ever up. */
    var cartDrawer = q('.pb-cart-drawer');
    if (cartDrawer) new MutationObserver(function () { if (cartDrawer.classList.contains('is-active')) close(); }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    var sheet = q('.pp-booking[data-pp-msheet]'), mark0 = null, slot = q('[data-pp-mslot]');
    SHEET = sheet; SLOT = slot;
    function place() {
      if (!sheet || !slot) return;
      if (MQ.matches) {
        if (!mark0 && sheet.parentNode !== slot && sheet.parentNode !== document.body) { mark0 = document.createComment('pp-booking'); sheet.parentNode.insertBefore(mark0, sheet); }
        if (!document.documentElement.classList.contains('pp-msheet-open') && sheet.parentNode !== slot) { slot.appendChild(sheet); sheet.classList.remove('pp-sheet'); sheet.classList.add('pp-inline'); }
      } else if (mark0) {
        close();
        mark0.parentNode.insertBefore(sheet, mark0); sheet.classList.remove('pp-sheet', 'pp-inline');
      }
    }
    /*  The bar steps aside the moment the card's top edge reaches it (the observed edge
        is the bar's top, via a bottom margin equal to the bar's height), so the card's
        own top takes over where the bar was. */
    function watch() {
      if (!slot || !window.IntersectionObserver) return;
      var h = (q('[data-pp-mdrawer]') || {}).offsetHeight || 76;
      if (watch.io) watch.io.disconnect();
      watch.io = new IntersectionObserver(function (es) {
        var e = es[0];
        document.documentElement.classList.toggle('pp-card-in', e.isIntersecting || e.boundingClientRect.top < 0);
      }, { rootMargin: '0px 0px -' + h + 'px 0px', threshold: 0 });
      watch.io.observe(slot);
    }
    place(); (MQ.addEventListener ? MQ.addEventListener('change', place) : MQ.addListener(place));
    watch(); window.addEventListener('resize', watch);
    var card = q('.pp-bc'); sync();
    if (card) new MutationObserver(sync).observe(card, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();


/* ─────────────────────────────────────────────────────────────
   OPTION DISPLAY SETTINGS — dev-build 323 (BUILD-323-BRIEF.md)
   Reads the data attributes each option container carries (ppb-mode-* and ppb-option)
   and adds: the badge, the explainer link, value descriptions, Start with (recommended
   or nothing), fold away once chosen, the toggle's off position, the fold-out list and
   the comparison table's chosen column. It never selects variants itself except by
   clicking a value button, so the card's own selection code stays the one owner.
   "Start with: nothing" holds Add to booking until a choice is made.
───────────────────────────────────────────────────────────────*/
(function () {
  function el(t, c, txt) { var e = document.createElement(t); if (c) e.className = c; if (txt != null) e.textContent = txt; return e; }
  function sel(c) { return c.querySelector('.pp-bcm-variant.is-selected'); }
  function labelOf(b) {
    if (!b) return '';
    var l = b.querySelector('.pp-bcm-x-v__label, .pp-bcm-variant-title');
    return (l ? l.childNodes[0] && l.childNodes[0].nodeType === 3 ? l.childNodes[0].textContent : l.textContent : b.dataset.value || '').trim();
  }
  function descOf(b) {
    if (!b) return '';
    if (b.dataset.desc) return b.dataset.desc;
    var s = b.querySelector('.pp-bcm-variant-subtitle'); return s ? s.textContent.trim() : '';
  }
  function refresh(c) {
    var b = sel(c);
    var d = c.querySelector(':scope > .pp-bcm-x-desc');
    if (d) { var t = c.dataset.await === '1' ? '' : descOf(b); d.textContent = t; d.hidden = !t;
      /*  426 (2a), restored in 440: 430 was built on an older copy of this file and dropped it.
          Puts the callout's pointer under the chosen segment. */
      if (!d.hidden && b && c.classList.contains('pp-bcm-x--segmented')) {
        var bx = c.querySelector(':scope > .pp-bcm-x-box');
        if (bx) { var br = bx.getBoundingClientRect(), r = b.getBoundingClientRect(); if (br.width) d.style.setProperty('--x-caret', Math.round(r.left - br.left + r.width / 2) + 'px'); }
      } }
    var fv = c.querySelector('[data-x-fold-value]');
    if (fv) fv.textContent = c.dataset.await === '1' ? 'Choose one' : labelOf(b);
    /* 590: the closed dropdown shows the price difference beside the chosen value. */
    if (fv && c.classList.contains('pp-bcm-x--fold-out')) {
      var fp = c.querySelector('[data-x-fold-price]');
      if (!fp) { fp = document.createElement('span'); fp.className = 'pp-bcm-x-fold__price'; fp.setAttribute('data-x-fold-price', ''); fv.insertAdjacentElement('afterend', fp); }
      var bp = b && c.dataset.await !== '1' ? b.querySelector('.pp-bcm-x-v__price') : null;
      fp.textContent = bp ? bp.textContent.trim() : '';
    }
    if (c.classList.contains('pp-bcm-x--table') && b) {
      var btns = Array.prototype.slice.call(c.querySelectorAll('.pp-bcm-variant')), i = btns.indexOf(b);
      c.querySelectorAll('.pp-bcm-x-t-cell').forEach(function (x) { x.classList.toggle('is-col-on', +x.dataset.col === i && c.dataset.await !== '1'); });
    }
    var sum = c.querySelector(':scope > .pp-bcm-x-summary');
    if (sum) {
      var p = b && b.querySelector('.pp-bcm-x-v__price, .pp-bcm-variant-row-price, .pp-bcm-variant-row-price-first');
      sum.querySelector('.pp-bcm-x-summary__label').textContent = labelOf(b) + (p && p.textContent.trim() ? '  ·  ' + p.textContent.trim() : '');
    }
  }
  function chosen(c) {
    if (c.dataset.await === '1') { c.dataset.await = '0'; var h = c.querySelector(':scope > .pp-bcm-x-await'); if (h) h.hidden = true; }
    if (c.classList.contains('pp-bcm-x--fold-out')) { c.classList.remove('is-open'); var t = c.querySelector('[data-x-fold-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    /* 590: dropdowns never fold into a "Change" summary — the closed field already shows the choice. */
    if (c.dataset.fold === 'true' && !c.classList.contains('pp-bcm-x--fold-out')) { c.classList.add('is-folded'); var s = c.querySelector(':scope > .pp-bcm-x-summary'); if (s) s.hidden = false; }
    refresh(c);
  }
  function setup(c) {
    if (c.dataset.xReady) return; c.dataset.xReady = '1';
    var top = c.querySelector('.pp-bcm-variant-top'), box = c.querySelector(':scope > .pp-bcm-variant-box, :scope > .pp-bcm-variant-box--dropdown');
    var bv = c.dataset.badgeValue;
    if (bv) c.querySelectorAll('.pp-bcm-variant').forEach(function (b) { if (b.dataset.value === bv && !b.querySelector('.pp-bcm-x-badge')) b.insertBefore(el('span', 'pp-bcm-x-badge', c.dataset.badgeText || 'Most popular'), b.firstChild); });
    if (c.dataset.infoText && top) {
      var link = el('button', 'pp-bcm-x-info', c.dataset.infoLabel || 'What\u2019s the difference?'); link.type = 'button';
      var panel = el('div', 'pp-bcm-x-info-panel', c.dataset.infoText); panel.hidden = true;
      link.addEventListener('click', function (e) { e.preventDefault(); panel.hidden = !panel.hidden; });
      top.appendChild(link); top.insertAdjacentElement('afterend', panel);
    }
    if (c.dataset.fold === 'true' && top) {
      var s = el('div', 'pp-bcm-x-summary'); s.hidden = true;
      s.innerHTML = '<span class="pp-bcm-x-summary__tick"><svg viewBox="0 0 12 12" width="10" height="10"><path d="M2.4 6.3 4.9 8.7 9.6 3.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="square"/></svg></span><span class="pp-bcm-x-summary__label"></span><button type="button">Change</button>';
      s.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); c.classList.remove('is-folded'); s.hidden = true;
        /* 434: on a dropdown, "Change" opens the list again rather than just showing the closed box. */
        if (c.classList.contains('pp-bcm-x--fold-out')) { c.classList.add('is-open'); var t = c.querySelector('[data-x-fold-toggle]'); if (t) { t.setAttribute('aria-expanded', 'true'); t.focus(); } } });
      (c.querySelector(':scope > .pp-bcm-x-info-panel') || top).insertAdjacentElement('afterend', s);
    }
    if (c.dataset.showDesc === 'true' && box) { var d = el('p', 'pp-bcm-x-desc'); d.hidden = true; box.insertAdjacentElement('afterend', d); }
    if (c.dataset.start === 'none') {
      c.dataset.await = '1';
      var h = el('p', 'pp-bcm-x-await', 'Choose one to add this to your booking.'); h.hidden = true; c.appendChild(h);
    } else if (c.dataset.start === 'recommended' && !c.classList.contains('pp-bcm-x')) {
      var rb = Array.prototype.find.call(c.querySelectorAll('.pp-bcm-variant'), function (b) { return b.dataset.value === c.dataset.recommended; });
      if (rb && !rb.classList.contains('is-selected')) rb.click();
      var rs = c.querySelector('.pp-bcm-variant-select');
      if (rs && Array.prototype.some.call(rs.options, function (o) { return o.value === c.dataset.recommended; }) && rs.value !== c.dataset.recommended) { rs.value = c.dataset.recommended; rs.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    c.addEventListener('click', function (e) {
      var t = e.target.closest('[data-x-fold-toggle]');
      if (t) { e.preventDefault(); var o = c.classList.toggle('is-open'); t.setAttribute('aria-expanded', o ? 'true' : 'false'); return; }
      var b = e.target.closest('.pp-bcm-x--toggle .pp-bcm-x-v.is-selected');
      if (b && !b.classList.contains('pp-bcm-x-v--off') && c.dataset.await !== '1') {
        var off = c.querySelector('.pp-bcm-x-v--off');
        if (off) { e.preventDefault(); e.stopPropagation(); off.click(); }
      }
    }, true);
    c.addEventListener('click', function (e) { if (e.target.closest('.pp-bcm-variant')) setTimeout(function () { chosen(c); }, 0); });
    c.addEventListener('change', function (e) { if (e.target.closest('.pp-bcm-variant-select')) setTimeout(function () { chosen(c); }, 0); });
    refresh(c);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pp-booking-card-btn');
    if (!btn) return;
    var waiting = document.querySelectorAll('.pp-bcm-variant-container[data-await="1"]');
    if (!waiting.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    waiting.forEach(function (c) { var h = c.querySelector(':scope > .pp-bcm-x-await'); if (h) h.hidden = false; });
    var r = waiting[0].getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight) window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' });
  }, true);
  function start() { document.querySelectorAll('.pp-bcm-variant-container').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); }); else setTimeout(start, 0);
})();

/*  ═══════════════════════════════════════════════════════════════════════════
    dev-build 430 — numbered steps, 5a (Ben 14-10-2026, Booking Card Fixes.dc.html)
    Every option group in the booking card, then quantity, gets a step number before
    its heading and the current choice at the right. The note moves under the heading.
    Hidden groups are skipped, so the numbers always run 1, 2, 3 on screen.
    ═══════════════════════════════════════════════════════════════════════════ */
(function () {
    function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
    function pickOf(g) {
        if (g.classList.contains('pp-bcm-qty-mode')) { var v = g.querySelector('.pp-bcm-qty-value'); return v ? clean(v.textContent) : ''; }
        var f = g.querySelector('[data-x-fold-value]'); if (f) return clean(f.textContent);
        var s = g.querySelector('select'); if (s && s.selectedOptions && s.selectedOptions[0]) return clean(s.selectedOptions[0].textContent).split(' · ')[0];
        var b = g.querySelector('.pp-bcm-variant.is-selected, [aria-pressed="true"], [aria-checked="true"], .is-selected');
        if (!b) return '';
        var l = b.querySelector('.pp-bcm-x-v__label, .pp-bcm-variant-title, .pp-bcm-x-t-label');
        var t = l ? l.textContent : (b.getAttribute('data-value') || b.textContent);
        return clean(t).split(' (')[0];
    }
    function run() {
        var card = document.querySelector('.pp-bc') || document; var n = 0;
        card.querySelectorAll('.pp-bcm-variant-container, .pp-bcm-qty-mode').forEach(function (g) {
            var top = g.querySelector(':scope > .pp-bcm-variant-top, :scope > .pp-booking-card-mode-top');
            if (!top) return;
            if (g.offsetParent === null) { g.classList.remove('has-step'); return; }
            n++;
            g.classList.add('has-step');
            var badge = top.querySelector(':scope > .pp-bc-step');
            if (!badge) { badge = document.createElement('span'); badge.className = 'pp-bc-step'; badge.setAttribute('aria-hidden', 'true'); top.insertBefore(badge, top.firstChild); }
            badge.textContent = n;
            /* 431: the choice is already on screen under the heading, so it is not repeated beside it. */
        });
    }
    var t; function soon() { clearTimeout(t); t = setTimeout(run, 30); }
    document.addEventListener('click', soon, true);
    document.addEventListener('change', soon, true);
    /* 436: numbering moved to CSS (a counter), so this no longer runs. */
    window.djwStepsRefresh = function () {};
})();

/*  dev-build 434 (Ben 15-10-2026): the Hire total always shows cents ($100.00). Many paths
    write it, so the element is watched and any whole-dollar figure gets ".00". */
(function () {
    var el = document.querySelector('.pp-bc .pp-booking-card-price') || document.querySelector('.pp-booking-card-price');
    if (!el) return;
    function fix() {
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, changed = false;
        while ((n = w.nextNode())) {
            if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('pp-booking-card-price-from')) continue;
            var v = n.nodeValue.replace(/\$(\d[\d,]*)(?![\d,]*\.\d)/g, '$$$1.00');
            if (v !== n.nodeValue) { n.nodeValue = v; changed = true; }
        }
        return changed;
    }
    fix();
    new MutationObserver(function () { fix(); }).observe(el, { childList: true, characterData: true, subtree: true });
})();

/*  dev-build 437: lift the price placeholder once the nights line is written (the last
    thing the price update sets), or after 3s so it can never stick. */
(function () {
    var top = document.querySelector('.pp-booking-card-price-top.is-price-pending'); if (!top) return;
    var nights = top.querySelector('.pp-booking-card-price-for-nights');
    function done() { top.classList.remove('is-price-pending'); if (mo) mo.disconnect(); }
    var mo = nights ? new MutationObserver(function () { if ((nights.textContent || '').trim()) requestAnimationFrame(done); }) : null;
    if (mo) mo.observe(nights, { childList: true, characterData: true, subtree: true });
    if (nights && (nights.textContent || '').trim()) done();
    setTimeout(done, 3000);
})();

/*  ═══════════════════════════════════════════════════════════════════════════
    dev-build 516 (Ben 20-10-2026): option prices follow the hire length.
    The rows were priced in Liquid as the cheapest variant for each value across
    every hire period, so they always showed the 1-night price. Each value is now
    priced inside the current hire period (from the booking's charged nights; 1 night
    when no dates are set), with the other options as currently chosen. Re-runs on
    load, on every option change and when the booking bar saves.
    ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  var nights = 1;
  function pid() { var el = document.querySelector('[data-product-gid]'); return el ? (el.dataset.productGid || '').replace('gid://shopify/Product/', '') : ''; }
  function hp(variants) { return typeof getMatrixOption1 === 'function' ? getMatrixOption1(nights, variants) : (variants[0] && variants[0].option1); }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toLocaleString('en-AU') : d.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }
  function chosenMap() {
    var m = {};
    document.querySelectorAll('.pp-bcm-variant.is-selected[data-option-index]').forEach(function (b) { m[+b.dataset.optionIndex] = b.dataset.value; });
    document.querySelectorAll('.pp-bcm-variant-select').forEach(function (s) { var o = s.options[s.selectedIndex]; if (o && o.dataset.value) m[+s.dataset.optionIndex] = o.dataset.value; });
    return m;
  }
  function priceOf(vs, o1, map, idx, val) {
    var want = Object.assign({}, map); want[idx] = val; delete want[0];
    var exact = vs.find(function (v) { return v.option1 === o1 && Object.keys(want).every(function (k) { return v['option' + (+k + 1)] === want[k]; }); });
    if (exact) return exact.price;
    var best = null;
    vs.forEach(function (v) { if (v.option1 === o1 && v['option' + (idx + 1)] === val && (best === null || v.price < best)) best = v.price; });
    return best;
  }
  function run() {
    run.__done = true;
    var d = window.ppProductData && window.ppProductData[pid()]; if (!d || !d.variants || !d.variants.length) return;
    var vs = d.variants, o1 = hp(vs), map = chosenMap();
    document.querySelectorAll('.pp-bcm-x[data-option-index]').forEach(function (c) {
      var idx = +c.dataset.optionIndex; if (idx === 0) return;
      var ppv = c.dataset.ppv || 'full'; if (ppv === 'off') return;
      var btns = Array.prototype.slice.call(c.querySelectorAll('.pp-bcm-variant[data-value]')); if (!btns.length) return;
      var base = priceOf(vs, o1, map, idx, btns[0].dataset.value);
      btns.forEach(function (b, i) {
        var p = priceOf(vs, o1, map, idx, b.dataset.value); if (p === null) return;
        b.dataset.variantPrice = (p / 100).toFixed(2);
        var s = b.querySelector('.pp-bcm-x-v__price'); if (!s) return;
        if (ppv === 'difference') { if (i === 0 || base === null) return; s.textContent = '+' + money(p - base); }
        else s.textContent = money(p);
      });
    });
  }
  window.ppbRepriceOptions = run;
  function readNights() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      /*  518: the booking card's own "N charged" line wins. The cart can still hold the old
          nights for a moment after a save, and applying it flipped the prices back and
          forth (the stutter). The cart is only used when the card shows no count. */
      var card = typeof fromCard === 'function' ? fromCard() : null;
      var n = card || parseInt((c.attributes || {})['Charged nights'], 10);
      n = n > 0 ? n : 1;
      if (n !== nights || !run.__done) { nights = n; run(); }
    }).catch(run);
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.pp-bcm-variant')) setTimeout(run, 0); });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.pp-bcm-variant-select')) setTimeout(run, 0); });
  /*  517: one cart read 300ms after the save was often too early (the new charged nights
      land later), so the prices kept the old hire length until a refresh. Now: read the
      cart several times after any save, and also watch the booking card's own
      "· N charged" line, which updates the moment the dates change. */
  function fromCard() {
    var card = document.querySelector('.pp-bc, .pp-booking-card'); if (!card) return null;
    var m = (card.textContent || '').match(/(\d+)\s+charged/i); return m ? parseInt(m[1], 10) : null;
  }
  function settle() { [150, 600, 1500, 3000].forEach(function (t) { setTimeout(readNights, t); }); }
  document.addEventListener('bookingbar:changed', function (e) {
    var dt = (e && e.detail) || {};
    if (dt.cleared) { nights = 1; run(); }
    settle();
  });
  ['bookingbar:saved', 'cart:updated', 'pp:dates-changed'].forEach(function (ev) { document.addEventListener(ev, settle); });
  var cardTimer = null;
  function watchCard() {
    var card = document.querySelector('.pp-bc, .pp-booking-card'); if (!card || card.__ppbWatch) return; card.__ppbWatch = true;
    new MutationObserver(function () {
      clearTimeout(cardTimer);
      cardTimer = setTimeout(function () { var n = fromCard(); if (n && n !== nights) { nights = n; run(); } }, 60);
    }).observe(card, { childList: true, characterData: true, subtree: true });
  }
  function boot() { readNights(); watchCard(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* 596 (Ben 22-10): booked-out option values, and a short "checking" skeleton on the status.
   An option value is booked out for the chosen dates + branch when it is in a cascade
   (blockedOptions) or every variant it would give, with the other picks as they are, is
   named in a block record (variantBlocked). Uses the shared blackout rule only. */
(function () {
  /* 598: the blackout rule loads after this file on some pages, so reading it once at the
     top left B empty and the module quit before it ran. It is looked up on every run now. */
  var B = null;
  function pid() { var c = document.querySelector('[data-product-id]'); return c ? c.getAttribute('data-product-id') : (window.meta && window.meta.product && window.meta.product.id); }
  function locGid(name) {
    var all = window.locationMetaobjects; if (!all || !name) return null;
    var m = Object.keys(all).map(function (k) { return all[k]; }).find(function (l) { return (l.name || '') === name; });
    return m ? (String(m.gid).indexOf('gid://') === 0 ? String(m.gid) : 'gid://shopify/Metaobject/' + m.gid) : null;
  }
  function picks() {
    var p = {};
    document.querySelectorAll('.pp-bcm-x[data-option-index]').forEach(function (c) {
      var s = c.querySelector('.pp-bcm-variant.is-selected[data-value]'); if (s) p[+c.dataset.optionIndex] = s.dataset.value;
    });
    return p;
  }
  function norm(s) { return String(s == null ? '' : s).replace(/\s*\([^)]*\)\s*$/, '').trim().toLowerCase(); }
  function same(a, b) { return a === b || norm(a) === norm(b); }
  function hireFor(vs, n) {
    var seen = {}, best = null, bestLo = -1;
    vs.forEach(function (v) {
      var s = String(v.option1 || ''); if (seen[s]) return; seen[s] = 1;
      var m = s.match(/(\d+)\s*(?:-\s*(\d+))?/); if (!m) return;
      var lo = +m[1], hi = m[2] ? +m[2] : lo;
      if (/week/i.test(s)) { lo = (lo - 1) * 7 + 4; hi = (+(m[2] || m[1])) * 7; }
      if (n >= lo && n <= hi) { best = s; bestLo = 1e9; }
      else if (bestLo < 1e9 && lo <= n && lo > bestLo) { best = s; bestLo = lo; }
    });
    return best;
  }
  function mark(ctx) {
    B = window.DJWBlackout; if (!B) return;
    var id = pid(), d = window.ppProductData && window.ppProductData[id]; if (!d || !d.variants) return;
    var pg = 'gid://shopify/Product/' + id, dated = !!(ctx.start && ctx.end);
    var cas = dated ? (B.blockedOptions(pg, ctx.start, ctx.end, ctx.loc) || []) : [];
    var casVals = {}; cas.forEach(function (o) { (o.values || []).forEach(function (v) { casVals[v] = true; }); });
    var p = picks();
    /* 600: the hire period isn't on the card as a pick, so p had no option1 and a value only
       counted as booked out if every hire length was blacked out. Take it from the nights. */
    if (p[0] === undefined && ctx.nights) { var hp = hireFor(d.variants, ctx.nights); if (hp) p[0] = hp; }
    document.querySelectorAll('.pp-bcm-x[data-option-index]').forEach(function (c) {
      var idx = +c.dataset.optionIndex; if (idx === 0) return;
      c.querySelectorAll('.pp-bcm-variant[data-value]').forEach(function (b) {
        var val = b.dataset.value, out = false;
        if (dated) {
          if (casVals[val]) out = true;
          else {
            /* 599: the button's value can be a short label ("Add Chrome Covers") while the
               variant's is "Add Chrome Covers (1 per light)". Compare without the bracket part. */
            var cands = d.variants.filter(function (v) {
              if (!same(v['option' + (idx + 1)], val)) return false;
              return Object.keys(p).every(function (k) { k = +k; return k === idx || same(v['option' + (k + 1)], p[k]); });
            });
            out = cands.length > 0 && cands.every(function (v) { return B.variantBlocked('gid://shopify/ProductVariant/' + v.id, ctx.start, ctx.end, ctx.loc); });
          }
        }
        if (out && b.classList.contains('is-selected')) out = false; /* never strand the current choice */
        b.classList.toggle('is-bookedout', out);
        b.toggleAttribute('disabled', out);
        var tag = b.querySelector('.pp-bcm-x-v__out');
        if (out && !tag) { tag = document.createElement('span'); tag.className = 'pp-bcm-x-v__out'; tag.textContent = 'Booked out'; b.appendChild(tag); }
        if (!out && tag) tag.remove();
      });
    });
  }
  function run() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var a = c.attributes || {}; mark({ start: a._pick_up_iso || '', end: a._return_iso || '', loc: locGid(a['Location'] || ''), nights: parseInt(a['Charged nights'], 10) || 0 });
    }).catch(function () {});
  }
  var t = 0;
  function checking() {
    var pill = document.querySelector('.pp-bc [data-pp-bc-pill]'); if (!pill) return;
    /* 602: the status code rewrites the pill's whole class list when a choice changes, which
       wiped "is-checking" the instant it was added. A data attribute survives that. */
    /* 620: 619 rewrote the status text and watched it, which fought the code that also
       watches it and froze the page. Now the real text is only hidden, and a twin span
       saying "Checking…" sits in its place — same element type, same styles, no fighting. */
    var tx = pill.querySelector('[data-pp-bc-pill-text]'); if (!tx) return;
    var tw = pill.querySelector('.pp-bc-pill__checking');
    if (!tw) { tw = document.createElement('span'); tw.className = 'pp-bc-pill__checking'; tw.textContent = 'Checking\u2026'; tx.parentNode.insertBefore(tw, tx); }
    /* 621: the twin copies the real text's exact type, read before it hides. */
    var cs = getComputedStyle(tx); ['fontFamily','fontSize','fontWeight','lineHeight','letterSpacing'].forEach(function (k) { tw.style[k] = cs[k]; });
    pill.setAttribute('data-checking', '');
    clearTimeout(t); t = setTimeout(function () { pill.removeAttribute('data-checking'); var w = pill.querySelector('.pp-bc-pill__checking'); if (w) w.remove(); }, 700);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.pp-bcm-variant')) { checking(); setTimeout(run, 0); }
    else if (e.target.closest('.pp-bcm-qty-mode button, .pp-bcm-qty-presets-btns button')) checking();
  });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.pp-bcm-qty-mode input, .pp-bcm-variant-select')) { checking(); setTimeout(run, 0); } });
  document.addEventListener('bookingbar:changed', function () { setTimeout(run, 400); });
  document.addEventListener('djw:cart', function () { setTimeout(run, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.ppbMarkBookedOut = run;
  /* 599: close the gap between an open dropdown's field and its list, whatever spacing
     the container puts between its children. */
  function joinOpen() {
    document.querySelectorAll('.pp-bcm-x--fold-out').forEach(function (c) {
      var f = c.querySelector('.pp-bcm-x-fold'), b = c.querySelector(':scope > .pp-bcm-x-box'); if (!f || !b) return;
      b.style.marginTop = '';
      if (!c.classList.contains('is-open')) return;
      var gap = b.getBoundingClientRect().top - f.getBoundingClientRect().bottom;
      var cur = parseFloat(getComputedStyle(b).marginTop) || 0;
      if (Math.abs(gap) > 0.5) b.style.setProperty('margin-top', (cur - gap) + 'px', 'important');
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.pp-bcm-x--fold-out')) requestAnimationFrame(joinOpen); });
  window.addEventListener('resize', joinOpen);
})();

/* 657: the bond confidence point. It copies the total the bond block works out, and its
   "More info" opens the same pop-up the bond block's link does. Only the bond block is
   watched; the point is written to and never watched, so nothing can loop. */
(function () {
  function sync() {
    var src = document.querySelector('[data-bc-bond] [data-bc-bond-total]');
    document.querySelectorAll('[data-bc-bond-pt-total]').forEach(function (d) { if (src && src.textContent.trim() && d.textContent !== src.textContent) d.textContent = src.textContent; });
  }
  function init() {
    sync();
    var src = document.querySelector('[data-bc-bond] [data-bc-bond-total]');
    if (src && window.MutationObserver) new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bc-bond-pt-more]'); if (!a) return;
    var real = document.querySelector('[data-bc-bond-more]');
    if (real) { e.preventDefault(); real.click(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 661 (#258): an open dropdown on the booking card closes when you click or tap anywhere
   outside it, or press Esc. The current pick is kept. */
(function () {
  if (window.__djwFoldClose) return; window.__djwFoldClose = 1;
  function closeAll(except) {
    document.querySelectorAll('.pp-bcm-x--fold-out.is-open').forEach(function (c) {
      if (except && c.contains(except)) return;
      c.classList.remove('is-open');
      var t = c.querySelector('[data-x-fold-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  /* 662: phones — iOS doesn't always send pointerdown for taps on plain page areas, so
     touchstart and click are listened for too. All run before other handlers (capture). */
  ['pointerdown', 'touchstart', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { closeAll(e.target); }, { capture: true, passive: true });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
